import { EventEmitter, gameStateEngineModule } from '@kiigame/kgae_ts';

function isPromise(object) {
    const isObjectOrFunction = (typeof object === 'object' && object !== null) ||
        typeof object === 'function';
    return (isObjectOrFunction && typeof object.then === 'function');
}

function stringifyServiceIdentifier(serviceIdentifier) {
    switch (typeof serviceIdentifier) {
        case 'string':
        case 'symbol':
            return serviceIdentifier.toString();
        case 'function':
            return serviceIdentifier.name;
        default:
            throw new Error(`Unexpected ${typeof serviceIdentifier} service id type`);
    }
}

const islazyServiceIdentifierSymbol = Symbol.for('@inversifyjs/common/islazyServiceIdentifier');
class LazyServiceIdentifier {
    [islazyServiceIdentifierSymbol];
    #buildServiceId;
    constructor(buildServiceId) {
        this.#buildServiceId = buildServiceId;
        this[islazyServiceIdentifierSymbol] = true;
    }
    static is(value) {
        return (typeof value === 'object' &&
            value !== null &&
            value[islazyServiceIdentifierSymbol] === true);
    }
    unwrap() {
        return this.#buildServiceId();
    }
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var ReflectLite = {};

/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var hasRequiredReflectLite;

function requireReflectLite () {
	if (hasRequiredReflectLite) return ReflectLite;
	hasRequiredReflectLite = 1;
	var Reflect;
	(function (Reflect) {
	    // Metadata Proposal
	    // https://rbuckton.github.io/reflect-metadata/
	    (function (factory) {
	        var root = typeof globalThis === "object" ? globalThis :
	            typeof commonjsGlobal === "object" ? commonjsGlobal :
	                typeof self === "object" ? self :
	                    typeof this === "object" ? this :
	                        sloppyModeThis();
	        var exporter = makeExporter(Reflect);
	        if (typeof root.Reflect !== "undefined") {
	            exporter = makeExporter(root.Reflect, exporter);
	        }
	        factory(exporter, root);
	        if (typeof root.Reflect === "undefined") {
	            root.Reflect = Reflect;
	        }
	        function makeExporter(target, previous) {
	            return function (key, value) {
	                Object.defineProperty(target, key, { configurable: true, writable: true, value: value });
	                if (previous)
	                    previous(key, value);
	            };
	        }
	        function sloppyModeThis() {
	            throw new ReferenceError("globalThis could not be found. Please polyfill globalThis before loading this module.");
	        }
	    })(function (exporter, root) {
	        // feature test for Symbol support
	        var supportsSymbol = typeof Symbol === "function";
	        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : fail("Symbol.toPrimitive not found.");
	        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : fail("Symbol.iterator not found.");
	        // Load global or shim versions of Map, Set, and WeakMap
	        var functionPrototype = Object.getPrototypeOf(Function);
	        var _Map = typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : fail("A valid Map constructor could not be found.");
	        var _Set = typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : fail("A valid Set constructor could not be found.");
	        var _WeakMap = typeof WeakMap === "function" ? WeakMap : fail("A valid WeakMap constructor could not be found.");
	        var registrySymbol = supportsSymbol ? Symbol.for("@reflect-metadata:registry") : undefined;
	        var metadataRegistry = GetOrCreateMetadataRegistry();
	        var metadataProvider = CreateMetadataProvider(metadataRegistry);
	        /**
	         * Applies a set of decorators to a property of a target object.
	         * @param decorators An array of decorators.
	         * @param target The target object.
	         * @param propertyKey (Optional) The property key to decorate.
	         * @param attributes (Optional) The property descriptor for the target key.
	         * @remarks Decorators are applied in reverse order.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     Example = Reflect.decorate(decoratorsArray, Example);
	         *
	         *     // property (on constructor)
	         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     Object.defineProperty(Example, "staticMethod",
	         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
	         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
	         *
	         *     // method (on prototype)
	         *     Object.defineProperty(Example.prototype, "method",
	         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
	         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
	         *
	         */
	        function decorate(decorators, target, propertyKey, attributes) {
	            if (!IsUndefined(propertyKey)) {
	                if (!IsArray(decorators))
	                    throw new TypeError();
	                if (!IsObject(target))
	                    throw new TypeError();
	                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes))
	                    throw new TypeError();
	                if (IsNull(attributes))
	                    attributes = undefined;
	                propertyKey = ToPropertyKey(propertyKey);
	                return DecorateProperty(decorators, target, propertyKey, attributes);
	            }
	            else {
	                if (!IsArray(decorators))
	                    throw new TypeError();
	                if (!IsConstructor(target))
	                    throw new TypeError();
	                return DecorateConstructor(decorators, target);
	            }
	        }
	        exporter("decorate", decorate);
	        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
	        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
	        /**
	         * A default metadata decorator factory that can be used on a class, class member, or parameter.
	         * @param metadataKey The key for the metadata entry.
	         * @param metadataValue The value for the metadata entry.
	         * @returns A decorator function.
	         * @remarks
	         * If `metadataKey` is already defined for the target and target key, the
	         * metadataValue for that key will be overwritten.
	         * @example
	         *
	         *     // constructor
	         *     @Reflect.metadata(key, value)
	         *     class Example {
	         *     }
	         *
	         *     // property (on constructor, TypeScript only)
	         *     class Example {
	         *         @Reflect.metadata(key, value)
	         *         static staticProperty;
	         *     }
	         *
	         *     // property (on prototype, TypeScript only)
	         *     class Example {
	         *         @Reflect.metadata(key, value)
	         *         property;
	         *     }
	         *
	         *     // method (on constructor)
	         *     class Example {
	         *         @Reflect.metadata(key, value)
	         *         static staticMethod() { }
	         *     }
	         *
	         *     // method (on prototype)
	         *     class Example {
	         *         @Reflect.metadata(key, value)
	         *         method() { }
	         *     }
	         *
	         */
	        function metadata(metadataKey, metadataValue) {
	            function decorator(target, propertyKey) {
	                if (!IsObject(target))
	                    throw new TypeError();
	                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
	                    throw new TypeError();
	                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
	            }
	            return decorator;
	        }
	        exporter("metadata", metadata);
	        /**
	         * Define a unique metadata entry on the target.
	         * @param metadataKey A key used to store and retrieve metadata.
	         * @param metadataValue A value that contains attached metadata.
	         * @param target The target object on which to define metadata.
	         * @param propertyKey (Optional) The property key for the target.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     Reflect.defineMetadata("custom:annotation", options, Example);
	         *
	         *     // property (on constructor)
	         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
	         *
	         *     // decorator factory as metadata-producing annotation.
	         *     function MyAnnotation(options): Decorator {
	         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
	         *     }
	         *
	         */
	        function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
	        }
	        exporter("defineMetadata", defineMetadata);
	        /**
	         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
	         * @param metadataKey A key used to store and retrieve metadata.
	         * @param target The target object on which the metadata is defined.
	         * @param propertyKey (Optional) The property key for the target.
	         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     result = Reflect.hasMetadata("custom:annotation", Example);
	         *
	         *     // property (on constructor)
	         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
	         *
	         */
	        function hasMetadata(metadataKey, target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
	        }
	        exporter("hasMetadata", hasMetadata);
	        /**
	         * Gets a value indicating whether the target object has the provided metadata key defined.
	         * @param metadataKey A key used to store and retrieve metadata.
	         * @param target The target object on which the metadata is defined.
	         * @param propertyKey (Optional) The property key for the target.
	         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
	         *
	         *     // property (on constructor)
	         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
	         *
	         */
	        function hasOwnMetadata(metadataKey, target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
	        }
	        exporter("hasOwnMetadata", hasOwnMetadata);
	        /**
	         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
	         * @param metadataKey A key used to store and retrieve metadata.
	         * @param target The target object on which the metadata is defined.
	         * @param propertyKey (Optional) The property key for the target.
	         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     result = Reflect.getMetadata("custom:annotation", Example);
	         *
	         *     // property (on constructor)
	         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
	         *
	         */
	        function getMetadata(metadataKey, target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
	        }
	        exporter("getMetadata", getMetadata);
	        /**
	         * Gets the metadata value for the provided metadata key on the target object.
	         * @param metadataKey A key used to store and retrieve metadata.
	         * @param target The target object on which the metadata is defined.
	         * @param propertyKey (Optional) The property key for the target.
	         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
	         *
	         *     // property (on constructor)
	         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
	         *
	         */
	        function getOwnMetadata(metadataKey, target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
	        }
	        exporter("getOwnMetadata", getOwnMetadata);
	        /**
	         * Gets the metadata keys defined on the target object or its prototype chain.
	         * @param target The target object on which the metadata is defined.
	         * @param propertyKey (Optional) The property key for the target.
	         * @returns An array of unique metadata keys.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     result = Reflect.getMetadataKeys(Example);
	         *
	         *     // property (on constructor)
	         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
	         *
	         */
	        function getMetadataKeys(target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            return OrdinaryMetadataKeys(target, propertyKey);
	        }
	        exporter("getMetadataKeys", getMetadataKeys);
	        /**
	         * Gets the unique metadata keys defined on the target object.
	         * @param target The target object on which the metadata is defined.
	         * @param propertyKey (Optional) The property key for the target.
	         * @returns An array of unique metadata keys.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     result = Reflect.getOwnMetadataKeys(Example);
	         *
	         *     // property (on constructor)
	         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
	         *
	         */
	        function getOwnMetadataKeys(target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            return OrdinaryOwnMetadataKeys(target, propertyKey);
	        }
	        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
	        /**
	         * Deletes the metadata entry from the target object with the provided key.
	         * @param metadataKey A key used to store and retrieve metadata.
	         * @param target The target object on which the metadata is defined.
	         * @param propertyKey (Optional) The property key for the target.
	         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
	         * @example
	         *
	         *     class Example {
	         *         // property declarations are not part of ES6, though they are valid in TypeScript:
	         *         // static staticProperty;
	         *         // property;
	         *
	         *         constructor(p) { }
	         *         static staticMethod(p) { }
	         *         method(p) { }
	         *     }
	         *
	         *     // constructor
	         *     result = Reflect.deleteMetadata("custom:annotation", Example);
	         *
	         *     // property (on constructor)
	         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
	         *
	         *     // property (on prototype)
	         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
	         *
	         *     // method (on constructor)
	         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
	         *
	         *     // method (on prototype)
	         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
	         *
	         */
	        function deleteMetadata(metadataKey, target, propertyKey) {
	            if (!IsObject(target))
	                throw new TypeError();
	            if (!IsUndefined(propertyKey))
	                propertyKey = ToPropertyKey(propertyKey);
	            var provider = GetMetadataProvider(target, propertyKey, /*Create*/ false);
	            if (IsUndefined(provider))
	                return false;
	            return provider.OrdinaryDeleteMetadata(metadataKey, target, propertyKey);
	        }
	        exporter("deleteMetadata", deleteMetadata);
	        function DecorateConstructor(decorators, target) {
	            for (var i = decorators.length - 1; i >= 0; --i) {
	                var decorator = decorators[i];
	                var decorated = decorator(target);
	                if (!IsUndefined(decorated) && !IsNull(decorated)) {
	                    if (!IsConstructor(decorated))
	                        throw new TypeError();
	                    target = decorated;
	                }
	            }
	            return target;
	        }
	        function DecorateProperty(decorators, target, propertyKey, descriptor) {
	            for (var i = decorators.length - 1; i >= 0; --i) {
	                var decorator = decorators[i];
	                var decorated = decorator(target, propertyKey, descriptor);
	                if (!IsUndefined(decorated) && !IsNull(decorated)) {
	                    if (!IsObject(decorated))
	                        throw new TypeError();
	                    descriptor = decorated;
	                }
	            }
	            return descriptor;
	        }
	        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
	        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
	        function OrdinaryHasMetadata(MetadataKey, O, P) {
	            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
	            if (hasOwn)
	                return true;
	            var parent = OrdinaryGetPrototypeOf(O);
	            if (!IsNull(parent))
	                return OrdinaryHasMetadata(MetadataKey, parent, P);
	            return false;
	        }
	        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
	        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
	        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
	            var provider = GetMetadataProvider(O, P, /*Create*/ false);
	            if (IsUndefined(provider))
	                return false;
	            return ToBoolean(provider.OrdinaryHasOwnMetadata(MetadataKey, O, P));
	        }
	        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
	        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
	        function OrdinaryGetMetadata(MetadataKey, O, P) {
	            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
	            if (hasOwn)
	                return OrdinaryGetOwnMetadata(MetadataKey, O, P);
	            var parent = OrdinaryGetPrototypeOf(O);
	            if (!IsNull(parent))
	                return OrdinaryGetMetadata(MetadataKey, parent, P);
	            return undefined;
	        }
	        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
	        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
	        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
	            var provider = GetMetadataProvider(O, P, /*Create*/ false);
	            if (IsUndefined(provider))
	                return;
	            return provider.OrdinaryGetOwnMetadata(MetadataKey, O, P);
	        }
	        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
	        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
	        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
	            var provider = GetMetadataProvider(O, P, /*Create*/ true);
	            provider.OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P);
	        }
	        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
	        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
	        function OrdinaryMetadataKeys(O, P) {
	            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
	            var parent = OrdinaryGetPrototypeOf(O);
	            if (parent === null)
	                return ownKeys;
	            var parentKeys = OrdinaryMetadataKeys(parent, P);
	            if (parentKeys.length <= 0)
	                return ownKeys;
	            if (ownKeys.length <= 0)
	                return parentKeys;
	            var set = new _Set();
	            var keys = [];
	            for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
	                var key = ownKeys_1[_i];
	                var hasKey = set.has(key);
	                if (!hasKey) {
	                    set.add(key);
	                    keys.push(key);
	                }
	            }
	            for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
	                var key = parentKeys_1[_a];
	                var hasKey = set.has(key);
	                if (!hasKey) {
	                    set.add(key);
	                    keys.push(key);
	                }
	            }
	            return keys;
	        }
	        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
	        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
	        function OrdinaryOwnMetadataKeys(O, P) {
	            var provider = GetMetadataProvider(O, P, /*create*/ false);
	            if (!provider) {
	                return [];
	            }
	            return provider.OrdinaryOwnMetadataKeys(O, P);
	        }
	        // 6 ECMAScript Data Types and Values
	        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
	        function Type(x) {
	            if (x === null)
	                return 1 /* Null */;
	            switch (typeof x) {
	                case "undefined": return 0 /* Undefined */;
	                case "boolean": return 2 /* Boolean */;
	                case "string": return 3 /* String */;
	                case "symbol": return 4 /* Symbol */;
	                case "number": return 5 /* Number */;
	                case "object": return x === null ? 1 /* Null */ : 6 /* Object */;
	                default: return 6 /* Object */;
	            }
	        }
	        // 6.1.1 The Undefined Type
	        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
	        function IsUndefined(x) {
	            return x === undefined;
	        }
	        // 6.1.2 The Null Type
	        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
	        function IsNull(x) {
	            return x === null;
	        }
	        // 6.1.5 The Symbol Type
	        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
	        function IsSymbol(x) {
	            return typeof x === "symbol";
	        }
	        // 6.1.7 The Object Type
	        // https://tc39.github.io/ecma262/#sec-object-type
	        function IsObject(x) {
	            return typeof x === "object" ? x !== null : typeof x === "function";
	        }
	        // 7.1 Type Conversion
	        // https://tc39.github.io/ecma262/#sec-type-conversion
	        // 7.1.1 ToPrimitive(input [, PreferredType])
	        // https://tc39.github.io/ecma262/#sec-toprimitive
	        function ToPrimitive(input, PreferredType) {
	            switch (Type(input)) {
	                case 0 /* Undefined */: return input;
	                case 1 /* Null */: return input;
	                case 2 /* Boolean */: return input;
	                case 3 /* String */: return input;
	                case 4 /* Symbol */: return input;
	                case 5 /* Number */: return input;
	            }
	            var hint = "string" ;
	            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
	            if (exoticToPrim !== undefined) {
	                var result = exoticToPrim.call(input, hint);
	                if (IsObject(result))
	                    throw new TypeError();
	                return result;
	            }
	            return OrdinaryToPrimitive(input);
	        }
	        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
	        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
	        function OrdinaryToPrimitive(O, hint) {
	            var valueOf, result; {
	                var toString_1 = O.toString;
	                if (IsCallable(toString_1)) {
	                    var result = toString_1.call(O);
	                    if (!IsObject(result))
	                        return result;
	                }
	                var valueOf = O.valueOf;
	                if (IsCallable(valueOf)) {
	                    var result = valueOf.call(O);
	                    if (!IsObject(result))
	                        return result;
	                }
	            }
	            throw new TypeError();
	        }
	        // 7.1.2 ToBoolean(argument)
	        // https://tc39.github.io/ecma262/2016/#sec-toboolean
	        function ToBoolean(argument) {
	            return !!argument;
	        }
	        // 7.1.12 ToString(argument)
	        // https://tc39.github.io/ecma262/#sec-tostring
	        function ToString(argument) {
	            return "" + argument;
	        }
	        // 7.1.14 ToPropertyKey(argument)
	        // https://tc39.github.io/ecma262/#sec-topropertykey
	        function ToPropertyKey(argument) {
	            var key = ToPrimitive(argument);
	            if (IsSymbol(key))
	                return key;
	            return ToString(key);
	        }
	        // 7.2 Testing and Comparison Operations
	        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
	        // 7.2.2 IsArray(argument)
	        // https://tc39.github.io/ecma262/#sec-isarray
	        function IsArray(argument) {
	            return Array.isArray
	                ? Array.isArray(argument)
	                : argument instanceof Object
	                    ? argument instanceof Array
	                    : Object.prototype.toString.call(argument) === "[object Array]";
	        }
	        // 7.2.3 IsCallable(argument)
	        // https://tc39.github.io/ecma262/#sec-iscallable
	        function IsCallable(argument) {
	            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
	            return typeof argument === "function";
	        }
	        // 7.2.4 IsConstructor(argument)
	        // https://tc39.github.io/ecma262/#sec-isconstructor
	        function IsConstructor(argument) {
	            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
	            return typeof argument === "function";
	        }
	        // 7.2.7 IsPropertyKey(argument)
	        // https://tc39.github.io/ecma262/#sec-ispropertykey
	        function IsPropertyKey(argument) {
	            switch (Type(argument)) {
	                case 3 /* String */: return true;
	                case 4 /* Symbol */: return true;
	                default: return false;
	            }
	        }
	        // 7.3 Operations on Objects
	        // https://tc39.github.io/ecma262/#sec-operations-on-objects
	        // 7.3.9 GetMethod(V, P)
	        // https://tc39.github.io/ecma262/#sec-getmethod
	        function GetMethod(V, P) {
	            var func = V[P];
	            if (func === undefined || func === null)
	                return undefined;
	            if (!IsCallable(func))
	                throw new TypeError();
	            return func;
	        }
	        // 7.4 Operations on Iterator Objects
	        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
	        function GetIterator(obj) {
	            var method = GetMethod(obj, iteratorSymbol);
	            if (!IsCallable(method))
	                throw new TypeError(); // from Call
	            var iterator = method.call(obj);
	            if (!IsObject(iterator))
	                throw new TypeError();
	            return iterator;
	        }
	        // 7.4.4 IteratorValue(iterResult)
	        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
	        function IteratorValue(iterResult) {
	            return iterResult.value;
	        }
	        // 7.4.5 IteratorStep(iterator)
	        // https://tc39.github.io/ecma262/#sec-iteratorstep
	        function IteratorStep(iterator) {
	            var result = iterator.next();
	            return result.done ? false : result;
	        }
	        // 7.4.6 IteratorClose(iterator, completion)
	        // https://tc39.github.io/ecma262/#sec-iteratorclose
	        function IteratorClose(iterator) {
	            var f = iterator["return"];
	            if (f)
	                f.call(iterator);
	        }
	        // 9.1 Ordinary Object Internal Methods and Internal Slots
	        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
	        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
	        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
	        function OrdinaryGetPrototypeOf(O) {
	            var proto = Object.getPrototypeOf(O);
	            if (typeof O !== "function" || O === functionPrototype)
	                return proto;
	            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
	            // Try to determine the superclass constructor. Compatible implementations
	            // must either set __proto__ on a subclass constructor to the superclass constructor,
	            // or ensure each class has a valid `constructor` property on its prototype that
	            // points back to the constructor.
	            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
	            // This is the case when in ES6 or when using __proto__ in a compatible browser.
	            if (proto !== functionPrototype)
	                return proto;
	            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
	            var prototype = O.prototype;
	            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
	            if (prototypeProto == null || prototypeProto === Object.prototype)
	                return proto;
	            // If the constructor was not a function, then we cannot determine the heritage.
	            var constructor = prototypeProto.constructor;
	            if (typeof constructor !== "function")
	                return proto;
	            // If we have some kind of self-reference, then we cannot determine the heritage.
	            if (constructor === O)
	                return proto;
	            // we have a pretty good guess at the heritage.
	            return constructor;
	        }
	        function fail(e) {
	            throw e;
	        }
	        // Global metadata registry
	        // - Allows `import "reflect-metadata"` and `import "reflect-metadata/no-conflict"` to interoperate.
	        // - Uses isolated metadata if `Reflect` is frozen before the registry can be installed.
	        /**
	         * Creates a registry used to allow multiple `reflect-metadata` providers.
	         */
	        function CreateMetadataRegistry() {
	            var fallback;
	            if (!IsUndefined(registrySymbol) &&
	                typeof root.Reflect !== "undefined" &&
	                !(registrySymbol in root.Reflect) &&
	                typeof root.Reflect.defineMetadata === "function") {
	                // interoperate with older version of `reflect-metadata` that did not support a registry.
	                fallback = CreateFallbackProvider(root.Reflect);
	            }
	            var first;
	            var second;
	            var rest;
	            var targetProviderMap = new _WeakMap();
	            var registry = {
	                registerProvider: registerProvider,
	                getProvider: getProvider,
	                setProvider: setProvider,
	            };
	            return registry;
	            function registerProvider(provider) {
	                if (!Object.isExtensible(registry)) {
	                    throw new Error("Cannot add provider to a frozen registry.");
	                }
	                switch (true) {
	                    case fallback === provider: break;
	                    case IsUndefined(first):
	                        first = provider;
	                        break;
	                    case first === provider: break;
	                    case IsUndefined(second):
	                        second = provider;
	                        break;
	                    case second === provider: break;
	                    default:
	                        if (rest === undefined)
	                            rest = new _Set();
	                        rest.add(provider);
	                        break;
	                }
	            }
	            function getProviderNoCache(O, P) {
	                if (!IsUndefined(first)) {
	                    if (first.isProviderFor(O, P))
	                        return first;
	                    if (!IsUndefined(second)) {
	                        if (second.isProviderFor(O, P))
	                            return first;
	                        if (!IsUndefined(rest)) {
	                            var iterator = GetIterator(rest);
	                            while (true) {
	                                var next = IteratorStep(iterator);
	                                if (!next) {
	                                    return undefined;
	                                }
	                                var provider = IteratorValue(next);
	                                if (provider.isProviderFor(O, P)) {
	                                    IteratorClose(iterator);
	                                    return provider;
	                                }
	                            }
	                        }
	                    }
	                }
	                if (!IsUndefined(fallback) && fallback.isProviderFor(O, P)) {
	                    return fallback;
	                }
	                return undefined;
	            }
	            function getProvider(O, P) {
	                var providerMap = targetProviderMap.get(O);
	                var provider;
	                if (!IsUndefined(providerMap)) {
	                    provider = providerMap.get(P);
	                }
	                if (!IsUndefined(provider)) {
	                    return provider;
	                }
	                provider = getProviderNoCache(O, P);
	                if (!IsUndefined(provider)) {
	                    if (IsUndefined(providerMap)) {
	                        providerMap = new _Map();
	                        targetProviderMap.set(O, providerMap);
	                    }
	                    providerMap.set(P, provider);
	                }
	                return provider;
	            }
	            function hasProvider(provider) {
	                if (IsUndefined(provider))
	                    throw new TypeError();
	                return first === provider || second === provider || !IsUndefined(rest) && rest.has(provider);
	            }
	            function setProvider(O, P, provider) {
	                if (!hasProvider(provider)) {
	                    throw new Error("Metadata provider not registered.");
	                }
	                var existingProvider = getProvider(O, P);
	                if (existingProvider !== provider) {
	                    if (!IsUndefined(existingProvider)) {
	                        return false;
	                    }
	                    var providerMap = targetProviderMap.get(O);
	                    if (IsUndefined(providerMap)) {
	                        providerMap = new _Map();
	                        targetProviderMap.set(O, providerMap);
	                    }
	                    providerMap.set(P, provider);
	                }
	                return true;
	            }
	        }
	        /**
	         * Gets or creates the shared registry of metadata providers.
	         */
	        function GetOrCreateMetadataRegistry() {
	            var metadataRegistry;
	            if (!IsUndefined(registrySymbol) && IsObject(root.Reflect) && Object.isExtensible(root.Reflect)) {
	                metadataRegistry = root.Reflect[registrySymbol];
	            }
	            if (IsUndefined(metadataRegistry)) {
	                metadataRegistry = CreateMetadataRegistry();
	            }
	            if (!IsUndefined(registrySymbol) && IsObject(root.Reflect) && Object.isExtensible(root.Reflect)) {
	                Object.defineProperty(root.Reflect, registrySymbol, {
	                    enumerable: false,
	                    configurable: false,
	                    writable: false,
	                    value: metadataRegistry
	                });
	            }
	            return metadataRegistry;
	        }
	        function CreateMetadataProvider(registry) {
	            // [[Metadata]] internal slot
	            // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
	            var metadata = new _WeakMap();
	            var provider = {
	                isProviderFor: function (O, P) {
	                    var targetMetadata = metadata.get(O);
	                    if (IsUndefined(targetMetadata))
	                        return false;
	                    return targetMetadata.has(P);
	                },
	                OrdinaryDefineOwnMetadata: OrdinaryDefineOwnMetadata,
	                OrdinaryHasOwnMetadata: OrdinaryHasOwnMetadata,
	                OrdinaryGetOwnMetadata: OrdinaryGetOwnMetadata,
	                OrdinaryOwnMetadataKeys: OrdinaryOwnMetadataKeys,
	                OrdinaryDeleteMetadata: OrdinaryDeleteMetadata,
	            };
	            metadataRegistry.registerProvider(provider);
	            return provider;
	            function GetOrCreateMetadataMap(O, P, Create) {
	                var targetMetadata = metadata.get(O);
	                var createdTargetMetadata = false;
	                if (IsUndefined(targetMetadata)) {
	                    if (!Create)
	                        return undefined;
	                    targetMetadata = new _Map();
	                    metadata.set(O, targetMetadata);
	                    createdTargetMetadata = true;
	                }
	                var metadataMap = targetMetadata.get(P);
	                if (IsUndefined(metadataMap)) {
	                    if (!Create)
	                        return undefined;
	                    metadataMap = new _Map();
	                    targetMetadata.set(P, metadataMap);
	                    if (!registry.setProvider(O, P, provider)) {
	                        targetMetadata.delete(P);
	                        if (createdTargetMetadata) {
	                            metadata.delete(O);
	                        }
	                        throw new Error("Wrong provider for target.");
	                    }
	                }
	                return metadataMap;
	            }
	            // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
	            // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
	            function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
	                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
	                if (IsUndefined(metadataMap))
	                    return false;
	                return ToBoolean(metadataMap.has(MetadataKey));
	            }
	            // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
	            // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
	            function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
	                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
	                if (IsUndefined(metadataMap))
	                    return undefined;
	                return metadataMap.get(MetadataKey);
	            }
	            // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
	            // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
	            function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
	                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
	                metadataMap.set(MetadataKey, MetadataValue);
	            }
	            // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
	            // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
	            function OrdinaryOwnMetadataKeys(O, P) {
	                var keys = [];
	                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
	                if (IsUndefined(metadataMap))
	                    return keys;
	                var keysObj = metadataMap.keys();
	                var iterator = GetIterator(keysObj);
	                var k = 0;
	                while (true) {
	                    var next = IteratorStep(iterator);
	                    if (!next) {
	                        keys.length = k;
	                        return keys;
	                    }
	                    var nextValue = IteratorValue(next);
	                    try {
	                        keys[k] = nextValue;
	                    }
	                    catch (e) {
	                        try {
	                            IteratorClose(iterator);
	                        }
	                        finally {
	                            throw e;
	                        }
	                    }
	                    k++;
	                }
	            }
	            function OrdinaryDeleteMetadata(MetadataKey, O, P) {
	                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
	                if (IsUndefined(metadataMap))
	                    return false;
	                if (!metadataMap.delete(MetadataKey))
	                    return false;
	                if (metadataMap.size === 0) {
	                    var targetMetadata = metadata.get(O);
	                    if (!IsUndefined(targetMetadata)) {
	                        targetMetadata.delete(P);
	                        if (targetMetadata.size === 0) {
	                            metadata.delete(targetMetadata);
	                        }
	                    }
	                }
	                return true;
	            }
	        }
	        function CreateFallbackProvider(reflect) {
	            var defineMetadata = reflect.defineMetadata, hasOwnMetadata = reflect.hasOwnMetadata, getOwnMetadata = reflect.getOwnMetadata, getOwnMetadataKeys = reflect.getOwnMetadataKeys, deleteMetadata = reflect.deleteMetadata;
	            var metadataOwner = new _WeakMap();
	            var provider = {
	                isProviderFor: function (O, P) {
	                    var metadataPropertySet = metadataOwner.get(O);
	                    if (!IsUndefined(metadataPropertySet) && metadataPropertySet.has(P)) {
	                        return true;
	                    }
	                    if (getOwnMetadataKeys(O, P).length) {
	                        if (IsUndefined(metadataPropertySet)) {
	                            metadataPropertySet = new _Set();
	                            metadataOwner.set(O, metadataPropertySet);
	                        }
	                        metadataPropertySet.add(P);
	                        return true;
	                    }
	                    return false;
	                },
	                OrdinaryDefineOwnMetadata: defineMetadata,
	                OrdinaryHasOwnMetadata: hasOwnMetadata,
	                OrdinaryGetOwnMetadata: getOwnMetadata,
	                OrdinaryOwnMetadataKeys: getOwnMetadataKeys,
	                OrdinaryDeleteMetadata: deleteMetadata,
	            };
	            return provider;
	        }
	        /**
	         * Gets the metadata provider for an object. If the object has no metadata provider and this is for a create operation,
	         * then this module's metadata provider is assigned to the object.
	         */
	        function GetMetadataProvider(O, P, Create) {
	            var registeredProvider = metadataRegistry.getProvider(O, P);
	            if (!IsUndefined(registeredProvider)) {
	                return registeredProvider;
	            }
	            if (Create) {
	                if (metadataRegistry.setProvider(O, P, metadataProvider)) {
	                    return metadataProvider;
	                }
	                throw new Error("Illegal state.");
	            }
	            return undefined;
	        }
	    });
	})(Reflect || (Reflect = {}));
	return ReflectLite;
}

requireReflectLite();

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
function getOwnReflectMetadata(target, metadataKey, propertyKey) {
    return Reflect.getOwnMetadata(metadataKey, target, propertyKey);
}

function setReflectMetadata(target, metadataKey, metadata, propertyKey) {
    Reflect.defineMetadata(metadataKey, metadata, target, propertyKey);
}

function updateOwnReflectMetadata(target, metadataKey, buildDefaultValue, callback, propertyKey) {
    const metadata = getOwnReflectMetadata(target, metadataKey, propertyKey) ??
        buildDefaultValue();
    const updatedMetadata = callback(metadata);
    Reflect.defineMetadata(metadataKey, updatedMetadata, target, propertyKey);
}

const ID_METADATA$1 = '@inversifyjs/container/bindingId';
function getContainerModuleId() {
    const bindingId = getOwnReflectMetadata(Object, ID_METADATA$1) ?? 0;
    if (bindingId === Number.MAX_SAFE_INTEGER) {
        setReflectMetadata(Object, ID_METADATA$1, Number.MIN_SAFE_INTEGER);
    }
    else {
        updateOwnReflectMetadata(Object, ID_METADATA$1, () => bindingId, (id) => id + 1);
    }
    return bindingId;
}

class ContainerModule {
    #id;
    #load;
    constructor(load) {
        this.#id = getContainerModuleId();
        this.#load = load;
    }
    get id() {
        return this.#id;
    }
    load(options) {
        return this.#load(options);
    }
}

const ID_METADATA = '@inversifyjs/container/bindingId';
function getBindingId() {
    const bindingId = getOwnReflectMetadata(Object, ID_METADATA) ?? 0;
    if (bindingId === Number.MAX_SAFE_INTEGER) {
        setReflectMetadata(Object, ID_METADATA, Number.MIN_SAFE_INTEGER);
    }
    else {
        updateOwnReflectMetadata(Object, ID_METADATA, () => bindingId, (id) => id + 1);
    }
    return bindingId;
}

const bindingScopeValues = {
    Request: 'Request',
    Singleton: 'Singleton',
    Transient: 'Transient',
};

const bindingTypeValues = {
    ConstantValue: 'ConstantValue',
    DynamicValue: 'DynamicValue',
    Factory: 'Factory',
    Instance: 'Instance',
    ResolvedValue: 'ResolvedValue',
    ServiceRedirection: 'ServiceRedirection',
};

function* chain(...iterables) {
    for (const iterable of iterables) {
        yield* iterable;
    }
}

const NOT_FOUND_INDEX = -1;
/**
 * Data structure able to efficiently manage a set of models related to a set of properties in a one to many relation.
 */
class OneToManyMapStar {
    #modelToRelationMap;
    #relationToModelsMaps;
    #spec;
    constructor(spec) {
        this.#modelToRelationMap = new Map();
        this.#relationToModelsMaps = {};
        for (const specProperty of Reflect.ownKeys(spec)) {
            this.#relationToModelsMaps[specProperty] = new Map();
        }
        this.#spec = spec;
    }
    add(model, relation) {
        this.#buildOrGetModelArray(model).push(relation);
        for (const relationKey of Reflect.ownKeys(relation)) {
            this.#buildOrGetRelationModels(relationKey, relation[relationKey]).push(model);
        }
    }
    clone() {
        const modelToCloneModelMap = this.#buildModelToCloneModelMap();
        const relationToCloneRelationMap = this.#buildRelationToRelationModelMap();
        const properties = Reflect.ownKeys(this.#spec);
        const clone = this._buildNewInstance(this.#spec);
        this.#pushRelationEntriesIntoRelationMap(this.#modelToRelationMap, clone.#modelToRelationMap, modelToCloneModelMap, relationToCloneRelationMap);
        for (const property of properties) {
            this.#pushModelEntriesIntoModelMap(this.#relationToModelsMaps[property], clone.#relationToModelsMaps[property], modelToCloneModelMap);
        }
        return clone;
    }
    get(key, value) {
        return this.#relationToModelsMaps[key].get(value);
    }
    getAllKeys(key) {
        return this.#relationToModelsMaps[key].keys();
    }
    removeByRelation(key, value) {
        const models = this.get(key, value);
        if (models === undefined) {
            return;
        }
        const uniqueModelsSet = new Set(models);
        for (const model of uniqueModelsSet) {
            const relations = this.#modelToRelationMap.get(model);
            if (relations === undefined) {
                throw new Error('Expecting model relation, none found');
            }
            for (const relation of relations) {
                if (relation[key] === value) {
                    this.#removeModelFromRelationMaps(model, relation);
                }
            }
            this.#modelToRelationMap.delete(model);
        }
    }
    _buildNewInstance(spec) {
        return new OneToManyMapStar(spec);
    }
    _cloneModel(model) {
        return model;
    }
    _cloneRelation(relation) {
        return relation;
    }
    #buildModelToCloneModelMap() {
        const modelToCloneModelMap = new Map();
        for (const model of this.#modelToRelationMap.keys()) {
            const clonedModel = this._cloneModel(model);
            modelToCloneModelMap.set(model, clonedModel);
        }
        return modelToCloneModelMap;
    }
    #buildRelationToRelationModelMap() {
        const relationToCloneRelationMap = new Map();
        for (const relations of this.#modelToRelationMap.values()) {
            for (const relation of relations) {
                const clonedRelation = this._cloneRelation(relation);
                relationToCloneRelationMap.set(relation, clonedRelation);
            }
        }
        return relationToCloneRelationMap;
    }
    #buildOrGetModelArray(model) {
        let relations = this.#modelToRelationMap.get(model);
        if (relations === undefined) {
            relations = [];
            this.#modelToRelationMap.set(model, relations);
        }
        return relations;
    }
    #buildOrGetRelationModels(relationKey, relationValue) {
        let models = this.#relationToModelsMaps[relationKey].get(relationValue);
        if (models === undefined) {
            models = [];
            this.#relationToModelsMaps[relationKey].set(relationValue, models);
        }
        return models;
    }
    #getCloneModel(model, modelToCloneModelMap) {
        const clonedModel = modelToCloneModelMap.get(model);
        if (clonedModel === undefined) {
            throw new Error('Expecting model to be cloned, none found');
        }
        return clonedModel;
    }
    #getCloneRelation(relation, relationToCloneRelationMap) {
        const clonedRelation = relationToCloneRelationMap.get(relation);
        if (clonedRelation === undefined) {
            throw new Error('Expecting relation to be cloned, none found');
        }
        return clonedRelation;
    }
    #pushModelEntriesIntoModelMap(source, target, modelToCloneModelMap) {
        for (const [relationValue, models] of source) {
            const modelsClone = new Array();
            for (const model of models) {
                modelsClone.push(this.#getCloneModel(model, modelToCloneModelMap));
            }
            target.set(relationValue, modelsClone);
        }
    }
    #pushRelationEntriesIntoRelationMap(source, target, modelToCloneModelMap, relationToCloneRelationMap) {
        for (const [model, relations] of source) {
            const relationsClone = new Array();
            for (const relation of relations) {
                relationsClone.push(this.#getCloneRelation(relation, relationToCloneRelationMap));
            }
            target.set(this.#getCloneModel(model, modelToCloneModelMap), relationsClone);
        }
    }
    #removeModelFromRelationMaps(model, relation) {
        for (const relationKey of Reflect.ownKeys(relation)) {
            this.#removeModelFromRelationMap(model, relationKey, relation[relationKey]);
        }
    }
    #removeModelFromRelationMap(model, relationKey, relationValue) {
        const relationModels = this.#relationToModelsMaps[relationKey].get(relationValue);
        if (relationModels !== undefined) {
            const index = relationModels.indexOf(model);
            if (index !== NOT_FOUND_INDEX) {
                relationModels.splice(index, 1);
            }
            if (relationModels.length === 0) {
                this.#relationToModelsMaps[relationKey].delete(relationValue);
            }
        }
    }
}

var ActivationRelationKind;
(function (ActivationRelationKind) {
    ActivationRelationKind["moduleId"] = "moduleId";
    ActivationRelationKind["serviceId"] = "serviceId";
})(ActivationRelationKind || (ActivationRelationKind = {}));
class ActivationsService {
    #activationMaps;
    #getParent;
    constructor(getParent, activationMaps) {
        this.#activationMaps =
            activationMaps ??
                new OneToManyMapStar({
                    moduleId: {
                        isOptional: true,
                    },
                    serviceId: {
                        isOptional: false,
                    },
                });
        this.#getParent = getParent;
    }
    static build(getParent) {
        return new ActivationsService(getParent);
    }
    add(activation, relation) {
        this.#activationMaps.add(activation, relation);
    }
    clone() {
        const clone = new ActivationsService(this.#getParent, this.#activationMaps.clone());
        return clone;
    }
    get(serviceIdentifier) {
        const activationIterables = [];
        const activations = this.#activationMaps.get(ActivationRelationKind.serviceId, serviceIdentifier);
        if (activations !== undefined) {
            activationIterables.push(activations);
        }
        const parentActivations = this.#getParent()?.get(serviceIdentifier);
        if (parentActivations !== undefined) {
            activationIterables.push(parentActivations);
        }
        if (activationIterables.length === 0) {
            return undefined;
        }
        return chain(...activationIterables);
    }
    removeAllByModuleId(moduleId) {
        this.#activationMaps.removeByRelation(ActivationRelationKind.moduleId, moduleId);
    }
    removeAllByServiceId(serviceId) {
        this.#activationMaps.removeByRelation(ActivationRelationKind.serviceId, serviceId);
    }
}

const classMetadataReflectKey = '@inversifyjs/core/classMetadataReflectKey';

function getDefaultClassMetadata() {
    return {
        constructorArguments: [],
        lifecycle: {
            postConstructMethodNames: new Set(),
            preDestroyMethodNames: new Set(),
        },
        properties: new Map(),
        scope: undefined,
    };
}

const pendingClassMetadataCountReflectKey = '@inversifyjs/core/pendingClassMetadataCountReflectKey';

function isPendingClassMetadata(type) {
    const pendingClassMetadataCount = getOwnReflectMetadata(type, pendingClassMetadataCountReflectKey);
    return (pendingClassMetadataCount !== undefined && pendingClassMetadataCount !== 0);
}

const isAppErrorSymbol$1 = Symbol.for('@inversifyjs/core/InversifyCoreError');
class InversifyCoreError extends Error {
    [isAppErrorSymbol$1];
    kind;
    constructor(kind, message, options) {
        super(message, options);
        this[isAppErrorSymbol$1] = true;
        this.kind = kind;
    }
    static is(value) {
        return (typeof value === 'object' &&
            value !== null &&
            value[isAppErrorSymbol$1] === true);
    }
    static isErrorOfKind(value, kind) {
        return InversifyCoreError.is(value) && value.kind === kind;
    }
}

var InversifyCoreErrorKind;
(function (InversifyCoreErrorKind) {
    InversifyCoreErrorKind[InversifyCoreErrorKind["injectionDecoratorConflict"] = 0] = "injectionDecoratorConflict";
    InversifyCoreErrorKind[InversifyCoreErrorKind["missingInjectionDecorator"] = 1] = "missingInjectionDecorator";
    InversifyCoreErrorKind[InversifyCoreErrorKind["planning"] = 2] = "planning";
    InversifyCoreErrorKind[InversifyCoreErrorKind["planningMaxDepthExceeded"] = 3] = "planningMaxDepthExceeded";
    InversifyCoreErrorKind[InversifyCoreErrorKind["resolution"] = 4] = "resolution";
    InversifyCoreErrorKind[InversifyCoreErrorKind["unknown"] = 5] = "unknown";
})(InversifyCoreErrorKind || (InversifyCoreErrorKind = {}));

var MaybeClassElementMetadataKind;
(function (MaybeClassElementMetadataKind) {
    MaybeClassElementMetadataKind[MaybeClassElementMetadataKind["unknown"] = 32] = "unknown";
})(MaybeClassElementMetadataKind || (MaybeClassElementMetadataKind = {}));

function throwAtInvalidClassMetadata(type, classMetadata) {
    const errors = [];
    for (let i = 0; i < classMetadata.constructorArguments.length; ++i) {
        const constructorArgument = classMetadata.constructorArguments[i];
        if (constructorArgument === undefined ||
            constructorArgument.kind === MaybeClassElementMetadataKind.unknown) {
            errors.push(`  - Missing or incomplete metadata for type "${type.name}" at constructor argument with index ${i.toString()}.
Every constructor parameter must be decorated either with @inject, @multiInject or @unmanaged decorator.`);
        }
    }
    for (const [propertyKey, property] of classMetadata.properties) {
        if (property.kind === MaybeClassElementMetadataKind.unknown) {
            errors.push(`  - Missing or incomplete metadata for type "${type.name}" at property "${propertyKey.toString()}".
This property must be decorated either with @inject or @multiInject decorator.`);
        }
    }
    if (errors.length === 0) {
        throw new InversifyCoreError(InversifyCoreErrorKind.unknown, `Unexpected class metadata for type "${type.name}" with uncompletion traces.
This might be caused by one of the following reasons:

1. A third party library is targeting inversify reflection metadata.
2. A bug is causing the issue. Consider submiting an issue to fix it.`);
    }
    throw new InversifyCoreError(InversifyCoreErrorKind.missingInjectionDecorator, `Invalid class metadata at type ${type.name}:

${errors.join('\n\n')}`);
}

function validateConstructorMetadataArray(type, value) {
    const undefinedIndexes = [];
    if (value.length < type.length) {
        throw new InversifyCoreError(InversifyCoreErrorKind.missingInjectionDecorator, `Found unexpected missing metadata on type "${type.name}". "${type.name}" constructor requires at least ${type.length.toString()} arguments, found ${value.length.toString()} instead.
Are you using @inject, @multiInject or @unmanaged decorators in every non optional constructor argument?

If you're using typescript and want to rely on auto injection, set "emitDecoratorMetadata" compiler option to true`);
    }
    // Using a for loop to ensure empty values are traversed as well
    for (let i = 0; i < value.length; ++i) {
        const element = value[i];
        if (element === undefined) {
            undefinedIndexes.push(i);
        }
    }
    if (undefinedIndexes.length > 0) {
        throw new InversifyCoreError(InversifyCoreErrorKind.missingInjectionDecorator, `Found unexpected missing metadata on type "${type.name}" at constructor indexes "${undefinedIndexes.join('", "')}".

Are you using @inject, @multiInject or @unmanaged decorators at those indexes?

If you're using typescript and want to rely on auto injection, set "emitDecoratorMetadata" compiler option to true`);
    }
}

function getClassMetadata(type) {
    const classMetadata = getOwnReflectMetadata(type, classMetadataReflectKey) ??
        getDefaultClassMetadata();
    if (isPendingClassMetadata(type)) {
        throwAtInvalidClassMetadata(type, classMetadata);
    }
    else {
        validateConstructorMetadataArray(type, classMetadata.constructorArguments);
        return classMetadata;
    }
}

function buildInstanceBinding(autobindOptions, serviceIdentifier) {
    const classMetadata = getClassMetadata(serviceIdentifier);
    const scope = classMetadata.scope ?? autobindOptions.scope;
    return {
        cache: {
            isRight: false,
            value: undefined,
        },
        id: getBindingId(),
        implementationType: serviceIdentifier,
        isSatisfiedBy: () => true,
        moduleId: undefined,
        onActivation: undefined,
        onDeactivation: undefined,
        scope,
        serviceIdentifier,
        type: bindingTypeValues.Instance,
    };
}

function cloneBindingCache(cache) {
    if (cache.isRight) {
        return {
            isRight: true,
            value: cache.value,
        };
    }
    // A left cache is not cloned, just returned
    return cache;
}

/**
 * Clones a ConstantValueBinding
 */
function cloneConstantValueBinding(binding) {
    return {
        cache: cloneBindingCache(binding.cache),
        id: binding.id,
        isSatisfiedBy: binding.isSatisfiedBy,
        moduleId: binding.moduleId,
        onActivation: binding.onActivation,
        onDeactivation: binding.onDeactivation,
        scope: binding.scope,
        serviceIdentifier: binding.serviceIdentifier,
        type: binding.type,
        // The value is not cloned as it's a resolved value
        value: binding.value,
    };
}

/**
 * Clones a DynamicValueBinding
 */
function cloneDynamicValueBinding(binding) {
    return {
        cache: cloneBindingCache(binding.cache),
        id: binding.id,
        isSatisfiedBy: binding.isSatisfiedBy,
        moduleId: binding.moduleId,
        onActivation: binding.onActivation,
        onDeactivation: binding.onDeactivation,
        scope: binding.scope,
        serviceIdentifier: binding.serviceIdentifier,
        type: binding.type,
        // The value is not cloned
        value: binding.value,
    };
}

/**
 * Clones a FactoryBinding
 */
function cloneFactoryBinding(binding) {
    return {
        cache: cloneBindingCache(binding.cache),
        factory: binding.factory,
        id: binding.id,
        isSatisfiedBy: binding.isSatisfiedBy,
        moduleId: binding.moduleId,
        onActivation: binding.onActivation,
        onDeactivation: binding.onDeactivation,
        scope: binding.scope,
        serviceIdentifier: binding.serviceIdentifier,
        type: binding.type,
    };
}

/**
 * Clones an InstanceBinding
 */
function cloneInstanceBinding(binding) {
    return {
        cache: cloneBindingCache(binding.cache),
        id: binding.id,
        implementationType: binding.implementationType,
        isSatisfiedBy: binding.isSatisfiedBy,
        moduleId: binding.moduleId,
        onActivation: binding.onActivation,
        onDeactivation: binding.onDeactivation,
        scope: binding.scope,
        serviceIdentifier: binding.serviceIdentifier,
        type: binding.type,
    };
}

/**
 * Clones a ResolvedValueBinding
 */
function cloneResolvedValueBinding(binding) {
    return {
        cache: cloneBindingCache(binding.cache),
        factory: binding.factory,
        id: binding.id,
        isSatisfiedBy: binding.isSatisfiedBy,
        metadata: binding.metadata,
        moduleId: binding.moduleId,
        onActivation: binding.onActivation,
        onDeactivation: binding.onDeactivation,
        scope: binding.scope,
        serviceIdentifier: binding.serviceIdentifier,
        type: binding.type,
    };
}

/**
 * Clones a ServiceRedirectionBinding
 */
function cloneServiceRedirectionBinding(binding) {
    return {
        id: binding.id,
        isSatisfiedBy: binding.isSatisfiedBy,
        moduleId: binding.moduleId,
        serviceIdentifier: binding.serviceIdentifier,
        targetServiceIdentifier: binding.targetServiceIdentifier,
        type: binding.type,
    };
}

/**
 * Creates a deep clone of a binding.
 *
 * @param binding - The binding to clone
 * @returns A clone of the binding
 */
function cloneBinding(binding) {
    // Switch based on binding type to delegate to specific clone functions
    switch (binding.type) {
        case bindingTypeValues.ConstantValue:
            return cloneConstantValueBinding(binding);
        case bindingTypeValues.DynamicValue:
            return cloneDynamicValueBinding(binding);
        case bindingTypeValues.Factory:
            return cloneFactoryBinding(binding);
        case bindingTypeValues.Instance:
            return cloneInstanceBinding(binding);
        case bindingTypeValues.ResolvedValue:
            return cloneResolvedValueBinding(binding);
        case bindingTypeValues.ServiceRedirection:
            return cloneServiceRedirectionBinding(binding);
    }
}

var BindingRelationKind;
(function (BindingRelationKind) {
    BindingRelationKind["id"] = "id";
    BindingRelationKind["moduleId"] = "moduleId";
    BindingRelationKind["serviceId"] = "serviceId";
})(BindingRelationKind || (BindingRelationKind = {}));
class OneToManyBindingMapStar extends OneToManyMapStar {
    _buildNewInstance(spec) {
        return new OneToManyBindingMapStar(spec);
    }
    _cloneModel(model) {
        return cloneBinding(model);
    }
}
class BindingService {
    #autobindOptions;
    #bindingMaps;
    #getParent;
    constructor(getParent, autobindOptions, bindingMaps) {
        this.#bindingMaps =
            bindingMaps ??
                new OneToManyBindingMapStar({
                    id: {
                        isOptional: false,
                    },
                    moduleId: {
                        isOptional: true,
                    },
                    serviceId: {
                        isOptional: false,
                    },
                });
        this.#getParent = getParent;
        this.#autobindOptions = autobindOptions;
    }
    static build(getParent, autobindOptions) {
        return new BindingService(getParent, autobindOptions);
    }
    clone() {
        const clone = new BindingService(this.#getParent, this.#autobindOptions, this.#bindingMaps.clone());
        return clone;
    }
    get(serviceIdentifier) {
        const bindings = this.getNonParentBindings(serviceIdentifier) ??
            this.#getParent()?.get(serviceIdentifier);
        if (bindings !== undefined) {
            return bindings;
        }
        const autoBoundBinding = this.#tryAutobind(serviceIdentifier);
        return autoBoundBinding === undefined
            ? autoBoundBinding
            : [autoBoundBinding];
    }
    *getChained(serviceIdentifier) {
        const currentBindings = this.getNonParentBindings(serviceIdentifier);
        if (currentBindings !== undefined) {
            yield* currentBindings;
        }
        const parent = this.#getParent();
        if (parent === undefined) {
            if (currentBindings === undefined) {
                const autobindBindings = this.#tryAutobind(serviceIdentifier);
                if (autobindBindings !== undefined) {
                    yield autobindBindings;
                }
            }
        }
        else {
            yield* parent.getChained(serviceIdentifier);
        }
    }
    getBoundServices() {
        const serviceIdentifierSet = new Set(this.#bindingMaps.getAllKeys(BindingRelationKind.serviceId));
        const parent = this.#getParent();
        if (parent !== undefined) {
            for (const serviceIdentifier of parent.getBoundServices()) {
                serviceIdentifierSet.add(serviceIdentifier);
            }
        }
        return serviceIdentifierSet;
    }
    getById(id) {
        return (this.#bindingMaps.get(BindingRelationKind.id, id) ?? this.#getParent()?.getById(id));
    }
    getByModuleId(moduleId) {
        return (this.#bindingMaps.get(BindingRelationKind.moduleId, moduleId) ?? this.#getParent()?.getByModuleId(moduleId));
    }
    getNonParentBindings(serviceId) {
        return this.#bindingMaps.get(BindingRelationKind.serviceId, serviceId);
    }
    getNonParentBoundServices() {
        return this.#bindingMaps.getAllKeys(BindingRelationKind.serviceId);
    }
    removeById(id) {
        this.#bindingMaps.removeByRelation(BindingRelationKind.id, id);
    }
    removeAllByModuleId(moduleId) {
        this.#bindingMaps.removeByRelation(BindingRelationKind.moduleId, moduleId);
    }
    removeAllByServiceId(serviceId) {
        this.#bindingMaps.removeByRelation(BindingRelationKind.serviceId, serviceId);
    }
    set(binding) {
        const relation = {
            [BindingRelationKind.id]: binding.id,
            [BindingRelationKind.serviceId]: binding.serviceIdentifier,
        };
        if (binding.moduleId !== undefined) {
            relation[BindingRelationKind.moduleId] = binding.moduleId;
        }
        this.#bindingMaps.add(binding, relation);
    }
    #tryAutobind(serviceIdentifier) {
        if (this.#autobindOptions === undefined ||
            typeof serviceIdentifier !== 'function') {
            return undefined;
        }
        const binding = buildInstanceBinding(this.#autobindOptions, serviceIdentifier);
        this.set(binding);
        return binding;
    }
}

var DeactivationRelationKind;
(function (DeactivationRelationKind) {
    DeactivationRelationKind["moduleId"] = "moduleId";
    DeactivationRelationKind["serviceId"] = "serviceId";
})(DeactivationRelationKind || (DeactivationRelationKind = {}));
class DeactivationsService {
    #deactivationMaps;
    #getParent;
    constructor(getParent, deactivationMaps) {
        this.#deactivationMaps =
            deactivationMaps ??
                new OneToManyMapStar({
                    moduleId: {
                        isOptional: true,
                    },
                    serviceId: {
                        isOptional: false,
                    },
                });
        this.#getParent = getParent;
    }
    static build(getParent) {
        return new DeactivationsService(getParent);
    }
    add(deactivation, relation) {
        this.#deactivationMaps.add(deactivation, relation);
    }
    clone() {
        const clone = new DeactivationsService(this.#getParent, this.#deactivationMaps.clone());
        return clone;
    }
    get(serviceIdentifier) {
        const deactivationIterables = [];
        const deactivations = this.#deactivationMaps.get(DeactivationRelationKind.serviceId, serviceIdentifier);
        if (deactivations !== undefined) {
            deactivationIterables.push(deactivations);
        }
        const parentDeactivations = this.#getParent()?.get(serviceIdentifier);
        if (parentDeactivations !== undefined) {
            deactivationIterables.push(parentDeactivations);
        }
        if (deactivationIterables.length === 0) {
            return undefined;
        }
        return chain(...deactivationIterables);
    }
    removeAllByModuleId(moduleId) {
        this.#deactivationMaps.removeByRelation(DeactivationRelationKind.moduleId, moduleId);
    }
    removeAllByServiceId(serviceId) {
        this.#deactivationMaps.removeByRelation(DeactivationRelationKind.serviceId, serviceId);
    }
}

function decorate(decorators, target, parameterIndexOrProperty, parameterIndex) {
    const parsedDecorators = Array.isArray(decorators)
        ? decorators
        : [decorators];
    if (parameterIndexOrProperty === undefined) {
        // Asume ClassDecorator[]
        Reflect.decorate(parsedDecorators, target);
        return;
    }
    if (typeof parameterIndexOrProperty === 'number') {
        // Asume ParameterDecorator[]
        for (const decorator of parsedDecorators) {
            decorator(target, undefined, parameterIndexOrProperty);
        }
        return;
    }
    {
        Reflect.decorate(parsedDecorators, target.prototype, parameterIndexOrProperty);
        return;
    }
}

function getDefaultPendingClassMetadataCount() {
    return 0;
}

function decrementPendingClassMetadataCount(type) {
    return (metadata) => {
        if (metadata !== undefined &&
            metadata.kind === MaybeClassElementMetadataKind.unknown) {
            updateOwnReflectMetadata(type, pendingClassMetadataCountReflectKey, getDefaultPendingClassMetadataCount, (count) => count - 1);
        }
    };
}

var ClassElementMetadataKind;
(function (ClassElementMetadataKind) {
    ClassElementMetadataKind[ClassElementMetadataKind["multipleInjection"] = 0] = "multipleInjection";
    ClassElementMetadataKind[ClassElementMetadataKind["singleInjection"] = 1] = "singleInjection";
    ClassElementMetadataKind[ClassElementMetadataKind["unmanaged"] = 2] = "unmanaged";
})(ClassElementMetadataKind || (ClassElementMetadataKind = {}));

function buildClassElementMetadataFromMaybeClassElementMetadata(buildDefaultMetadata, buildMetadataFromMaybeManagedMetadata) {
    return (...params) => (metadata) => {
        if (metadata === undefined) {
            return buildDefaultMetadata(...params);
        }
        if (metadata.kind === ClassElementMetadataKind.unmanaged) {
            throw new InversifyCoreError(InversifyCoreErrorKind.injectionDecoratorConflict, 'Unexpected injection found. Multiple @inject, @multiInject or @unmanaged decorators found');
        }
        return buildMetadataFromMaybeManagedMetadata(metadata, ...params);
    };
}

function buildDefaultManagedMetadata(kind, serviceIdentifier, options) {
    if (kind === ClassElementMetadataKind.multipleInjection) {
        return {
            chained: options?.chained ?? false,
            kind,
            name: undefined,
            optional: false,
            tags: new Map(),
            value: serviceIdentifier,
        };
    }
    else {
        return {
            kind,
            name: undefined,
            optional: false,
            tags: new Map(),
            value: serviceIdentifier,
        };
    }
}

function assertMetadataFromTypescriptIfManaged(metadata) {
    if (metadata.kind !== MaybeClassElementMetadataKind.unknown &&
        metadata.isFromTypescriptParamType !== true) {
        throw new InversifyCoreError(InversifyCoreErrorKind.injectionDecoratorConflict, 'Unexpected injection found. Multiple @inject, @multiInject or @unmanaged decorators found');
    }
}

function buildManagedMetadataFromMaybeManagedMetadata(metadata, kind, serviceIdentifier, options) {
    assertMetadataFromTypescriptIfManaged(metadata);
    if (kind === ClassElementMetadataKind.multipleInjection) {
        return {
            ...metadata,
            chained: options?.chained ?? false,
            kind,
            value: serviceIdentifier,
        };
    }
    else {
        return {
            ...metadata,
            kind,
            value: serviceIdentifier,
        };
    }
}

const buildManagedMetadataFromMaybeClassElementMetadata = buildClassElementMetadataFromMaybeClassElementMetadata(buildDefaultManagedMetadata, buildManagedMetadataFromMaybeManagedMetadata);

function updateMaybeClassMetadataConstructorArgument(updateMetadata, index) {
    return (classMetadata) => {
        const propertyMetadata = classMetadata.constructorArguments[index];
        classMetadata.constructorArguments[index] =
            updateMetadata(propertyMetadata);
        return classMetadata;
    };
}

function updateMaybeClassMetadataProperty(updateMetadata, propertyKey) {
    return (classMetadata) => {
        const propertyMetadata = classMetadata.properties.get(propertyKey);
        classMetadata.properties.set(propertyKey, updateMetadata(propertyMetadata));
        return classMetadata;
    };
}

var DecoratorInfoKind;
(function (DecoratorInfoKind) {
    DecoratorInfoKind[DecoratorInfoKind["method"] = 0] = "method";
    DecoratorInfoKind[DecoratorInfoKind["parameter"] = 1] = "parameter";
    DecoratorInfoKind[DecoratorInfoKind["property"] = 2] = "property";
})(DecoratorInfoKind || (DecoratorInfoKind = {}));

function getDecoratorInfo(target, propertyKey, parameterIndexOrDescriptor) {
    if (parameterIndexOrDescriptor === undefined) {
        if (propertyKey === undefined) {
            throw new InversifyCoreError(InversifyCoreErrorKind.unknown, 'Unexpected undefined property and index values');
        }
        return {
            kind: DecoratorInfoKind.property,
            property: propertyKey,
            targetClass: target.constructor,
        };
    }
    if (typeof parameterIndexOrDescriptor === 'number') {
        return {
            index: parameterIndexOrDescriptor,
            kind: DecoratorInfoKind.parameter,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
            targetClass: target,
        };
    }
    return {
        kind: DecoratorInfoKind.method,
        method: propertyKey,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
        targetClass: target,
    };
}

function stringifyDecoratorInfo(decoratorTargetInfo) {
    switch (decoratorTargetInfo.kind) {
        case DecoratorInfoKind.method:
            return `[class: "${decoratorTargetInfo.targetClass.name}", method: "${decoratorTargetInfo.method.toString()}"]`;
        case DecoratorInfoKind.parameter:
            return `[class: "${decoratorTargetInfo.targetClass.name}", index: "${decoratorTargetInfo.index.toString()}"]`;
        case DecoratorInfoKind.property:
            return `[class: "${decoratorTargetInfo.targetClass.name}", property: "${decoratorTargetInfo.property.toString()}"]`;
    }
}

function handleInjectionError(target, propertyKey, parameterIndex, error) {
    if (InversifyCoreError.isErrorOfKind(error, InversifyCoreErrorKind.injectionDecoratorConflict)) {
        const info = getDecoratorInfo(target, propertyKey, parameterIndex);
        throw new InversifyCoreError(InversifyCoreErrorKind.injectionDecoratorConflict, `Unexpected injection error.

Cause:

${error.message}

Details

${stringifyDecoratorInfo(info)}`, { cause: error });
    }
    throw error;
}

function injectBase(updateMetadata, updatePendingClassMetadataCount) {
    const decorator = (target, propertyKey, parameterIndexOrDescriptor) => {
        try {
            if (parameterIndexOrDescriptor === undefined) {
                injectProperty(updateMetadata, updatePendingClassMetadataCount)(target, propertyKey);
            }
            else {
                if (typeof parameterIndexOrDescriptor === 'number') {
                    injectParameter(updateMetadata, updatePendingClassMetadataCount)(target, propertyKey, parameterIndexOrDescriptor);
                }
                else {
                    injectMethod(updateMetadata, updatePendingClassMetadataCount)(target, propertyKey, parameterIndexOrDescriptor);
                }
            }
        }
        catch (error) {
            handleInjectionError(target, propertyKey, parameterIndexOrDescriptor, error);
        }
    };
    return decorator;
}
function buildComposedUpdateMetadata(updateMetadata, updatePendingClassMetadataCount) {
    return (target) => {
        const updateTargetPendingClassMetadataCount = updatePendingClassMetadataCount(target);
        return (metadata) => {
            updateTargetPendingClassMetadataCount(metadata);
            return updateMetadata(metadata);
        };
    };
}
function injectMethod(updateMetadata, updatePendingClassMetadataCount) {
    const buildComposedUpdateMetadataFromTarget = buildComposedUpdateMetadata(updateMetadata, updatePendingClassMetadataCount);
    return (target, propertyKey, descriptor) => {
        if (isPropertySetter(descriptor)) {
            updateOwnReflectMetadata(target.constructor, classMetadataReflectKey, getDefaultClassMetadata, updateMaybeClassMetadataProperty(buildComposedUpdateMetadataFromTarget(target), propertyKey));
        }
        else {
            throw new InversifyCoreError(InversifyCoreErrorKind.injectionDecoratorConflict, `Found an @inject decorator in a non setter property method.
Found @inject decorator at method "${propertyKey.toString()}" at class "${target.constructor.name}"`);
        }
    };
}
function injectParameter(updateMetadata, updatePendingClassMetadataCount) {
    const buildComposedUpdateMetadataFromTarget = buildComposedUpdateMetadata(updateMetadata, updatePendingClassMetadataCount);
    return (target, propertyKey, parameterIndex) => {
        if (isConstructorParameter(target, propertyKey)) {
            updateOwnReflectMetadata(target, classMetadataReflectKey, getDefaultClassMetadata, updateMaybeClassMetadataConstructorArgument(buildComposedUpdateMetadataFromTarget(target), parameterIndex));
        }
        else {
            throw new InversifyCoreError(InversifyCoreErrorKind.injectionDecoratorConflict, `Found an @inject decorator in a non constructor parameter.
Found @inject decorator at method "${propertyKey?.toString() ?? ''}" at class "${target.constructor.name}"`);
        }
    };
}
function injectProperty(updateMetadata, updatePendingClassMetadataCount) {
    const buildComposedUpdateMetadataFromTarget = buildComposedUpdateMetadata(updateMetadata, updatePendingClassMetadataCount);
    return (target, propertyKey) => {
        updateOwnReflectMetadata(target.constructor, classMetadataReflectKey, getDefaultClassMetadata, updateMaybeClassMetadataProperty(buildComposedUpdateMetadataFromTarget(target), propertyKey));
    };
}
function isConstructorParameter(target, propertyKey) {
    return typeof target === 'function' && propertyKey === undefined;
}
function isPropertySetter(descriptor) {
    return descriptor.set !== undefined;
}

function inject(serviceIdentifier) {
    const updateMetadata = buildManagedMetadataFromMaybeClassElementMetadata(ClassElementMetadataKind.singleInjection, serviceIdentifier);
    return injectBase(updateMetadata, decrementPendingClassMetadataCount);
}

const classIsInjectableFlagReflectKey = '@inversifyjs/core/classIsInjectableFlagReflectKey';

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function setIsInjectableFlag(target) {
    const isInjectableFlag = getOwnReflectMetadata(target, classIsInjectableFlagReflectKey);
    if (isInjectableFlag !== undefined) {
        throw new InversifyCoreError(InversifyCoreErrorKind.injectionDecoratorConflict, `Cannot apply @injectable decorator multiple times at class "${target.name}"`);
    }
    setReflectMetadata(target, classIsInjectableFlagReflectKey, true);
}

const typescriptParameterTypesReflectKey = 'design:paramtypes';

function buildClassElementMetadataFromTypescriptParameterType(type) {
    return {
        isFromTypescriptParamType: true,
        kind: ClassElementMetadataKind.singleInjection,
        name: undefined,
        optional: false,
        tags: new Map(),
        value: type,
    };
}

const NON_USERLAND_TYPES = [
    Array,
    BigInt,
    Boolean,
    Function,
    Number,
    Object,
    String,
];
function isUserlandEmittedType(type) {
    return !NON_USERLAND_TYPES.includes(type);
}

function updateClassMetadataWithTypescriptParameterTypes(target) {
    const typescriptConstructorArguments = getOwnReflectMetadata(target, typescriptParameterTypesReflectKey);
    if (typescriptConstructorArguments !== undefined) {
        updateOwnReflectMetadata(target, classMetadataReflectKey, getDefaultClassMetadata, updateMaybeClassMetadataWithTypescriptClassMetadata(typescriptConstructorArguments));
    }
}
function updateMaybeClassMetadataWithTypescriptClassMetadata(typescriptConstructorArguments) {
    return (classMetadata) => {
        typescriptConstructorArguments.forEach((constructorArgumentType, index) => {
            if (classMetadata.constructorArguments[index] === undefined &&
                isUserlandEmittedType(constructorArgumentType)) {
                classMetadata.constructorArguments[index] =
                    buildClassElementMetadataFromTypescriptParameterType(constructorArgumentType);
            }
        });
        return classMetadata;
    };
}

function injectable(scope) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    return (target) => {
        setIsInjectableFlag(target);
        updateClassMetadataWithTypescriptParameterTypes(target);
    };
}

var ResolvedValueElementMetadataKind;
(function (ResolvedValueElementMetadataKind) {
    ResolvedValueElementMetadataKind[ResolvedValueElementMetadataKind["multipleInjection"] = 0] = "multipleInjection";
    ResolvedValueElementMetadataKind[ResolvedValueElementMetadataKind["singleInjection"] = 1] = "singleInjection";
})(ResolvedValueElementMetadataKind || (ResolvedValueElementMetadataKind = {}));

function buildGetPlanOptionsFromPlanParams(params) {
    if (params.rootConstraints.isMultiple) {
        return {
            chained: params.rootConstraints.chained,
            isMultiple: true,
            name: params.rootConstraints.name,
            optional: params.rootConstraints.isOptional ?? false,
            serviceIdentifier: params.rootConstraints.serviceIdentifier,
            tag: params.rootConstraints.tag,
        };
    }
    else {
        return {
            isMultiple: false,
            name: params.rootConstraints.name,
            optional: params.rootConstraints.isOptional ?? false,
            serviceIdentifier: params.rootConstraints.serviceIdentifier,
            tag: params.rootConstraints.tag,
        };
    }
}

/*
 * V8 (Chrome, Node.js, Edge, Deno): "Maximum call stack size exceeded"
 * SpiderMonkey (Firefox): "too much recursion"
 * JavaScriptCore (Safari): "call stack size exceeded"
 * Chakra (IE/legacy Edge): "Out of stack space"
 */
const STACK_OVERFLOW_PATTERNS = /stack space|call stack|too much recursion/i;
// SpiderMonkey throws InternalError with "too much recursion"
const SPIDER_MONKEY_REGEXP = /too much recursion/;
function isStackOverflowError(error) {
    try {
        if (!(error instanceof Error)) {
            return false;
        }
        return (
        // V8 and JavaScriptCore typically throw RangeError
        (error instanceof RangeError &&
            STACK_OVERFLOW_PATTERNS.test(error.message)) ||
            (error.name === 'InternalError' &&
                SPIDER_MONKEY_REGEXP.test(error.message)));
    }
    catch (innerError) {
        /*
         * The following code flow can lead to a secondary stack overflow:
         * 1. Code flow triggers infinite recursion
         * 3. On V8, `RangeError: Maximum call stack size exceeded` is thrown
         * 4. `isStackOverflowError(error)` is called in a catch block
         * 5. regex.test()` is called when the call stack is nearly exhausted
         * 6. Regex execution requires stack space, causing a secondary stack overflow
         * 7. V8 reports this as: `SyntaxError: Invalid regular expression: ... Stack overflow`
         */
        return (innerError instanceof SyntaxError &&
            innerError.message.includes('Stack overflow'));
    }
}

/**
 * Extracts a likely circular dependency asuming a service asociated to a
 * service identifier should not be asociated to services asociated to the same
 * service identifier.
 *
 * Important note: given the current binding constraints, there's no way to know
 * which is exactly the circular dependency. Custom ancestor based constraints might
 * allow circular dependencies breaking the loop when a certain condition is met.
 *
 * @param params plan params
 */
function extractLikelyCircularDependency$1(params) {
    const serviceIdentifiers = new Set();
    for (const serviceIdentifier of params.servicesBranch) {
        if (serviceIdentifiers.has(serviceIdentifier)) {
            return [...serviceIdentifiers, serviceIdentifier];
        }
        serviceIdentifiers.add(serviceIdentifier);
    }
    return [...serviceIdentifiers];
}
function handlePlanError(params, error) {
    if (isStackOverflowError(error) ||
        InversifyCoreError.isErrorOfKind(error, InversifyCoreErrorKind.planningMaxDepthExceeded)) {
        const stringifiedCircularDependencies = stringifyServiceIdentifierTrace$1(extractLikelyCircularDependency$1(params));
        throw new InversifyCoreError(InversifyCoreErrorKind.planning, `Circular dependency found: ${stringifiedCircularDependencies}`, { cause: error });
    }
    throw error;
}
function stringifyServiceIdentifierTrace$1(serviceIdentifiers) {
    const serviceIdentifiersArray = [...serviceIdentifiers];
    if (serviceIdentifiersArray.length === 0) {
        return '(No dependency trace)';
    }
    return serviceIdentifiersArray.map(stringifyServiceIdentifier).join(' -> ');
}

const isLazyPlanServiceNodeSymbol = Symbol.for('@inversifyjs/core/LazyPlanServiceNode');
class LazyPlanServiceNode {
    [isLazyPlanServiceNodeSymbol];
    _serviceIdentifier;
    _serviceNode;
    constructor(serviceNode, serviceIdentifier) {
        this[isLazyPlanServiceNodeSymbol] = true;
        this._serviceNode = serviceNode;
        this._serviceIdentifier = serviceIdentifier;
    }
    get bindings() {
        return this._getNode().bindings;
    }
    get isContextFree() {
        return this._getNode().isContextFree;
    }
    get serviceIdentifier() {
        return this._serviceIdentifier;
    }
    set bindings(bindings) {
        this._getNode().bindings = bindings;
    }
    set isContextFree(isContextFree) {
        this._getNode().isContextFree = isContextFree;
    }
    static is(value) {
        return (typeof value === 'object' &&
            value !== null &&
            value[isLazyPlanServiceNodeSymbol] ===
                true);
    }
    invalidate() {
        this._serviceNode = undefined;
    }
    isExpanded() {
        return this._serviceNode !== undefined;
    }
    _getNode() {
        if (this._serviceNode === undefined) {
            this._serviceNode = this._buildPlanServiceNode();
        }
        return this._serviceNode;
    }
}

class BindingConstraintsImplementation {
    #node;
    constructor(node) {
        this.#node = node;
    }
    get name() {
        return this.#node.elem.name;
    }
    get serviceIdentifier() {
        return this.#node.elem.serviceIdentifier;
    }
    get tags() {
        return this.#node.elem.tags;
    }
    getAncestor() {
        this.#node.elem.getAncestorsCalled = true;
        if (this.#node.previous === undefined) {
            return undefined;
        }
        return new BindingConstraintsImplementation(this.#node.previous);
    }
}

function buildFilteredServiceBindings(params, bindingConstraints, options) {
    const serviceIdentifier = options?.customServiceIdentifier ?? bindingConstraints.serviceIdentifier;
    const serviceBindings = options?.chained === true
        ? [...params.operations.getBindingsChained(serviceIdentifier)]
        : [...(params.operations.getBindings(serviceIdentifier) ?? [])];
    const filteredBindings = serviceBindings.filter((binding) => binding.isSatisfiedBy(bindingConstraints));
    if (filteredBindings.length === 0 &&
        params.autobindOptions !== undefined &&
        typeof serviceIdentifier === 'function') {
        const binding = buildInstanceBinding(params.autobindOptions, serviceIdentifier);
        params.operations.setBinding(binding);
        if (binding.isSatisfiedBy(bindingConstraints)) {
            filteredBindings.push(binding);
        }
    }
    return filteredBindings;
}

class SingleImmutableLinkedList {
    last;
    length;
    constructor(last, length) {
        this.last = last;
        this.length = length;
    }
    concat(elem) {
        return new SingleImmutableLinkedList({
            elem,
            previous: this.last,
        }, this.length + 1);
    }
    [Symbol.iterator]() {
        let node = this.last;
        return {
            next: () => {
                if (node === undefined) {
                    return {
                        done: true,
                        value: undefined,
                    };
                }
                const elem = node.elem;
                node = node.previous;
                return {
                    done: false,
                    value: elem,
                };
            },
        };
    }
}

function buildPlanBindingConstraintsList(params) {
    const tags = new Map();
    if (params.rootConstraints.tag !== undefined) {
        tags.set(params.rootConstraints.tag.key, params.rootConstraints.tag.value);
    }
    return new SingleImmutableLinkedList({
        elem: {
            getAncestorsCalled: false,
            name: params.rootConstraints.name,
            serviceIdentifier: params.rootConstraints.serviceIdentifier,
            tags,
        },
        previous: undefined,
    }, 1);
}

function isPlanServiceRedirectionBindingNode(node) {
    return (node.redirections !==
        undefined);
}

function stringifyBinding(binding) {
    switch (binding.type) {
        case bindingTypeValues.Instance:
            return `[ type: "${binding.type}", serviceIdentifier: "${stringifyServiceIdentifier(binding.serviceIdentifier)}", scope: "${binding.scope}", implementationType: "${binding.implementationType.name}" ]`;
        case bindingTypeValues.ServiceRedirection:
            return `[ type: "${binding.type}", serviceIdentifier: "${stringifyServiceIdentifier(binding.serviceIdentifier)}", redirection: "${stringifyServiceIdentifier(binding.targetServiceIdentifier)}" ]`;
        default:
            return `[ type: "${binding.type}", serviceIdentifier: "${stringifyServiceIdentifier(binding.serviceIdentifier)}", scope: "${binding.scope}" ]`;
    }
}

function throwErrorWhenUnexpectedBindingsAmountFound(bindingNodes, isOptional, bindingConstraintNode, serviceRedirections) {
    const serviceIdentifier = bindingConstraintNode.elem.serviceIdentifier;
    const parentServiceIdentifier = bindingConstraintNode.previous?.elem.serviceIdentifier;
    if (Array.isArray(bindingNodes)) {
        throwErrorWhenMultipleUnexpectedBindingsAmountFound(bindingNodes, isOptional, serviceIdentifier, parentServiceIdentifier, bindingConstraintNode.elem, serviceRedirections);
    }
    else {
        throwErrorWhenSingleUnexpectedBindingFound(bindingNodes, isOptional, serviceIdentifier, parentServiceIdentifier, bindingConstraintNode.elem, serviceRedirections);
    }
}
function throwBindingNotFoundError(serviceIdentifier, parentServiceIdentifier, bindingConstraints, serviceRedirections) {
    const lastResolvedServiceIdentifier = serviceRedirections[serviceRedirections.length - 1] ?? serviceIdentifier;
    const errorMessage = `No bindings found for service: "${stringifyServiceIdentifier(lastResolvedServiceIdentifier)}".

Trying to resolve bindings for "${stringifyParentServiceIdentifier(serviceIdentifier, parentServiceIdentifier)}".${stringifyServiceRedirections(serviceRedirections)}${stringifyBindingConstraints(bindingConstraints)}`;
    throw new InversifyCoreError(InversifyCoreErrorKind.planning, errorMessage);
}
function throwErrorWhenMultipleUnexpectedBindingsAmountFound(bindingNodes, isOptional, serviceIdentifier, parentServiceIdentifier, bindingConstraints, serviceRedirections) {
    if (bindingNodes.length === 0) {
        if (!isOptional) {
            throwBindingNotFoundError(serviceIdentifier, parentServiceIdentifier, bindingConstraints, serviceRedirections);
        }
    }
    else {
        const lastResolvedServiceIdentifier = serviceRedirections[serviceRedirections.length - 1] ?? serviceIdentifier;
        const errorMessage = `Ambiguous bindings found for service: "${stringifyServiceIdentifier(lastResolvedServiceIdentifier)}".${stringifyServiceRedirections(serviceRedirections)}

Registered bindings:

${bindingNodes.map((bindingNode) => stringifyBinding(bindingNode.binding)).join('\n')}

Trying to resolve bindings for "${stringifyParentServiceIdentifier(serviceIdentifier, parentServiceIdentifier)}".${stringifyBindingConstraints(bindingConstraints)}`;
        throw new InversifyCoreError(InversifyCoreErrorKind.planning, errorMessage);
    }
}
function throwErrorWhenSingleUnexpectedBindingFound(bindingNode, isOptional, serviceIdentifier, parentServiceIdentifier, bindingConstraints, serviceRedirections) {
    if (bindingNode === undefined && !isOptional) {
        throwBindingNotFoundError(serviceIdentifier, parentServiceIdentifier, bindingConstraints, serviceRedirections);
    }
}
function stringifyParentServiceIdentifier(serviceIdentifier, parentServiceIdentifier) {
    return parentServiceIdentifier === undefined
        ? `${stringifyServiceIdentifier(serviceIdentifier)} (Root service)`
        : stringifyServiceIdentifier(parentServiceIdentifier);
}
function stringifyBindingConstraints(bindingConstraints) {
    const stringifiedTags = bindingConstraints.tags.size === 0
        ? ''
        : `
- tags:
  - ${[...bindingConstraints.tags.keys()].map((key) => key.toString()).join('\n  - ')}`;
    return `

Binding constraints:
- service identifier: ${stringifyServiceIdentifier(bindingConstraints.serviceIdentifier)}
- name: ${bindingConstraints.name?.toString() ?? '-'}${stringifiedTags}`;
}
function stringifyServiceRedirections(serviceRedirections) {
    return serviceRedirections.length === 0
        ? ''
        : `

- service redirections:
  - ${serviceRedirections
            .map((serviceIdentifier) => stringifyServiceIdentifier(serviceIdentifier))
            .join('\n  - ')}`;
}

const SINGLE_INJECTION_BINDINGS$1 = 1;
function checkPlanServiceRedirectionBindingNodeSingleInjectionBindings(serviceRedirectionBindingNode, isOptional, bindingConstraintNode, serviceRedirections) {
    if (serviceRedirectionBindingNode.redirections.length ===
        SINGLE_INJECTION_BINDINGS$1) {
        const [planBindingNode] = serviceRedirectionBindingNode.redirections;
        if (isPlanServiceRedirectionBindingNode(planBindingNode)) {
            checkPlanServiceRedirectionBindingNodeSingleInjectionBindings(planBindingNode, isOptional, bindingConstraintNode, [
                ...serviceRedirections,
                planBindingNode.binding.targetServiceIdentifier,
            ]);
        }
        return;
    }
    throwErrorWhenUnexpectedBindingsAmountFound(serviceRedirectionBindingNode.redirections, isOptional, bindingConstraintNode, serviceRedirections);
}

const SINGLE_INJECTION_BINDINGS = 1;
function checkServiceNodeSingleInjectionBindings(serviceNode, isOptional, bindingConstraintNode) {
    if (Array.isArray(serviceNode.bindings)) {
        if (serviceNode.bindings.length === SINGLE_INJECTION_BINDINGS) {
            const [planBindingNode] = serviceNode.bindings;
            if (isPlanServiceRedirectionBindingNode(planBindingNode)) {
                checkPlanServiceRedirectionBindingNodeSingleInjectionBindings(planBindingNode, isOptional, bindingConstraintNode, [planBindingNode.binding.targetServiceIdentifier]);
            }
            return;
        }
    }
    throwErrorWhenUnexpectedBindingsAmountFound(serviceNode.bindings, isOptional, bindingConstraintNode, []);
}

function curryBuildPlanServiceNode(buildServiceNodeBindings) {
    return (params) => {
        const bindingConstraintsList = buildPlanBindingConstraintsList(params);
        const bindingConstraints = new BindingConstraintsImplementation(bindingConstraintsList.last);
        const chained = params.rootConstraints.isMultiple && params.rootConstraints.chained;
        const filteredServiceBindings = buildFilteredServiceBindings(params, bindingConstraints, {
            chained,
        });
        const serviceNodeBindings = [];
        const serviceNode = {
            bindings: serviceNodeBindings,
            isContextFree: true,
            serviceIdentifier: params.rootConstraints.serviceIdentifier,
        };
        serviceNodeBindings.push(...buildServiceNodeBindings(params, bindingConstraintsList, filteredServiceBindings, serviceNode, chained));
        serviceNode.isContextFree =
            !bindingConstraintsList.last.elem.getAncestorsCalled;
        if (!params.rootConstraints.isMultiple) {
            checkServiceNodeSingleInjectionBindings(serviceNode, params.rootConstraints.isOptional ?? false, bindingConstraintsList.last);
            const [planBindingNode] = serviceNodeBindings;
            serviceNode.bindings = planBindingNode;
        }
        return serviceNode;
    };
}

function getServiceFromMaybeLazyServiceIdentifier(serviceIdentifier) {
    return LazyServiceIdentifier.is(serviceIdentifier)
        ? serviceIdentifier.unwrap()
        : serviceIdentifier;
}

function curryBuildPlanServiceNodeFromClassElementMetadata(buildServiceNodeBindings) {
    return (params, bindingConstraintsList, elementMetadata) => {
        const serviceIdentifier = getServiceFromMaybeLazyServiceIdentifier(elementMetadata.value);
        const updatedBindingConstraintsList = bindingConstraintsList.concat({
            getAncestorsCalled: false,
            name: elementMetadata.name,
            serviceIdentifier,
            tags: elementMetadata.tags,
        });
        const bindingConstraints = new BindingConstraintsImplementation(updatedBindingConstraintsList.last);
        const chained = elementMetadata.kind === ClassElementMetadataKind.multipleInjection &&
            elementMetadata.chained;
        const filteredServiceBindings = buildFilteredServiceBindings(params, bindingConstraints, {
            chained,
        });
        const serviceNodeBindings = [];
        const serviceNode = {
            bindings: serviceNodeBindings,
            isContextFree: true,
            serviceIdentifier,
        };
        serviceNodeBindings.push(...buildServiceNodeBindings(params, updatedBindingConstraintsList, filteredServiceBindings, serviceNode, chained));
        serviceNode.isContextFree =
            !updatedBindingConstraintsList.last.elem.getAncestorsCalled;
        if (elementMetadata.kind === ClassElementMetadataKind.singleInjection) {
            checkServiceNodeSingleInjectionBindings(serviceNode, elementMetadata.optional, updatedBindingConstraintsList.last);
            const [planBindingNode] = serviceNodeBindings;
            serviceNode.bindings = planBindingNode;
        }
        return serviceNode;
    };
}

function curryBuildPlanServiceNodeFromResolvedValueElementMetadata(buildServiceNodeBindings) {
    return (params, bindingConstraintsList, elementMetadata) => {
        const serviceIdentifier = getServiceFromMaybeLazyServiceIdentifier(elementMetadata.value);
        const updatedBindingConstraintsList = bindingConstraintsList.concat({
            getAncestorsCalled: false,
            name: elementMetadata.name,
            serviceIdentifier,
            tags: elementMetadata.tags,
        });
        const bindingConstraints = new BindingConstraintsImplementation(updatedBindingConstraintsList.last);
        const chained = elementMetadata.kind ===
            ResolvedValueElementMetadataKind.multipleInjection &&
            elementMetadata.chained;
        const filteredServiceBindings = buildFilteredServiceBindings(params, bindingConstraints, {
            chained,
        });
        const serviceNodeBindings = [];
        const serviceNode = {
            bindings: serviceNodeBindings,
            isContextFree: true,
            serviceIdentifier,
        };
        serviceNodeBindings.push(...buildServiceNodeBindings(params, updatedBindingConstraintsList, filteredServiceBindings, serviceNode, chained));
        serviceNode.isContextFree =
            !updatedBindingConstraintsList.last.elem.getAncestorsCalled;
        if (elementMetadata.kind === ResolvedValueElementMetadataKind.singleInjection) {
            checkServiceNodeSingleInjectionBindings(serviceNode, elementMetadata.optional, updatedBindingConstraintsList.last);
            const [planBindingNode] = serviceNodeBindings;
            serviceNode.bindings = planBindingNode;
        }
        return serviceNode;
    };
}

function curryBuildServiceNodeBindings(subplan) {
    const buildInstancePlanBindingNode = curryBuildInstancePlanBindingNode(subplan);
    const buildResolvedValuePlanBindingNode = curryBuildResolvedValuePlanBindingNode(subplan);
    const buildServiceNodeBindings = (params, bindingConstraintsList, serviceBindings, parentNode, chainedBindings) => {
        const serviceIdentifier = isPlanServiceRedirectionBindingNode(parentNode)
            ? parentNode.binding.targetServiceIdentifier
            : parentNode.serviceIdentifier;
        params.servicesBranch.push(serviceIdentifier);
        const planBindingNodes = [];
        for (const binding of serviceBindings) {
            switch (binding.type) {
                case bindingTypeValues.Instance: {
                    planBindingNodes.push(buildInstancePlanBindingNode(params, binding, bindingConstraintsList));
                    break;
                }
                case bindingTypeValues.ResolvedValue: {
                    planBindingNodes.push(buildResolvedValuePlanBindingNode(params, binding, bindingConstraintsList));
                    break;
                }
                case bindingTypeValues.ServiceRedirection: {
                    const planBindingNode = buildServiceRedirectionPlanBindingNode(params, bindingConstraintsList, binding, chainedBindings);
                    planBindingNodes.push(planBindingNode);
                    break;
                }
                default:
                    planBindingNodes.push({
                        binding: binding,
                    });
            }
        }
        params.servicesBranch.pop();
        return planBindingNodes;
    };
    const buildServiceRedirectionPlanBindingNode = curryBuildServiceRedirectionPlanBindingNode(buildServiceNodeBindings);
    return buildServiceNodeBindings;
}
function curryBuildInstancePlanBindingNode(subplan) {
    return (params, binding, bindingConstraintsList) => {
        const classMetadata = params.operations.getClassMetadata(binding.implementationType);
        const childNode = {
            binding: binding,
            classMetadata,
            constructorParams: [],
            propertyParams: new Map(),
        };
        const subplanParams = {
            autobindOptions: params.autobindOptions,
            node: childNode,
            operations: params.operations,
            servicesBranch: params.servicesBranch,
        };
        return subplan(subplanParams, bindingConstraintsList);
    };
}
function curryBuildResolvedValuePlanBindingNode(subplan) {
    return (params, binding, bindingConstraintsList) => {
        const childNode = {
            binding: binding,
            params: [],
        };
        const subplanParams = {
            autobindOptions: params.autobindOptions,
            node: childNode,
            operations: params.operations,
            servicesBranch: params.servicesBranch,
        };
        return subplan(subplanParams, bindingConstraintsList);
    };
}
function curryBuildServiceRedirectionPlanBindingNode(buildServiceNodeBindings) {
    return (params, bindingConstraintsList, binding, chainedBindings) => {
        const childNode = {
            binding,
            redirections: [],
        };
        const bindingConstraints = new BindingConstraintsImplementation(bindingConstraintsList.last);
        const filteredServiceBindings = buildFilteredServiceBindings(params, bindingConstraints, {
            chained: chainedBindings,
            customServiceIdentifier: binding.targetServiceIdentifier,
        });
        childNode.redirections.push(...buildServiceNodeBindings(params, bindingConstraintsList, filteredServiceBindings, childNode, chainedBindings));
        return childNode;
    };
}

function isInstanceBindingNode(node) {
    return node.binding.type === bindingTypeValues.Instance;
}

function tryBuildGetPlanOptionsFromManagedClassElementMetadata(elementMetadata) {
    let tag;
    if (elementMetadata.tags.size === 0) {
        tag = undefined;
    }
    else if (elementMetadata.tags.size === 1) {
        const [key, value] = elementMetadata.tags
            .entries()
            .next().value;
        tag = { key, value };
    }
    else {
        return undefined;
    }
    const serviceIdentifier = LazyServiceIdentifier.is(elementMetadata.value)
        ? elementMetadata.value.unwrap()
        : elementMetadata.value;
    if (elementMetadata.kind === ClassElementMetadataKind.multipleInjection) {
        return {
            chained: elementMetadata.chained,
            isMultiple: true,
            name: elementMetadata.name,
            optional: elementMetadata.optional,
            serviceIdentifier,
            tag,
        };
    }
    else {
        return {
            isMultiple: false,
            name: elementMetadata.name,
            optional: elementMetadata.optional,
            serviceIdentifier,
            tag,
        };
    }
}

function tryBuildGetPlanOptionsFromResolvedValueElementMetadata(resolvedValueElementMetadata) {
    let tag;
    if (resolvedValueElementMetadata.tags.size === 0) {
        tag = undefined;
    }
    else if (resolvedValueElementMetadata.tags.size === 1) {
        const [key, value] = resolvedValueElementMetadata.tags.entries().next().value;
        tag = { key, value };
    }
    else {
        return undefined;
    }
    const serviceIdentifier = LazyServiceIdentifier.is(resolvedValueElementMetadata.value)
        ? resolvedValueElementMetadata.value.unwrap()
        : resolvedValueElementMetadata.value;
    if (resolvedValueElementMetadata.kind ===
        ResolvedValueElementMetadataKind.multipleInjection) {
        return {
            chained: resolvedValueElementMetadata.chained,
            isMultiple: true,
            name: resolvedValueElementMetadata.name,
            optional: resolvedValueElementMetadata.optional,
            serviceIdentifier,
            tag,
        };
    }
    else {
        return {
            isMultiple: false,
            name: resolvedValueElementMetadata.name,
            optional: resolvedValueElementMetadata.optional,
            serviceIdentifier,
            tag,
        };
    }
}

function cacheNonRootPlanServiceNode(getPlanOptions, operations, planServiceNode, context) {
    if (getPlanOptions !== undefined &&
        ((LazyPlanServiceNode.is(planServiceNode) &&
            !planServiceNode.isExpanded()) ||
            planServiceNode.isContextFree)) {
        const planResult = {
            tree: {
                root: planServiceNode,
            },
        };
        operations.setPlan(getPlanOptions, planResult);
    }
    else {
        operations.setNonCachedServiceNode(planServiceNode, context);
    }
}

const MAX_PLAN_DEPTH = 500;
class LazyManagedClassMetadataPlanServiceNode extends LazyPlanServiceNode {
    #params;
    #buildLazyPlanServiceNodeNodeFromClassElementMetadata;
    #bindingConstraintsList;
    #elementMetadata;
    constructor(params, buildLazyPlanServiceNodeNodeFromClassElementMetadata, bindingConstraintsList, elementMetadata, serviceNode) {
        super(serviceNode, getServiceFromMaybeLazyServiceIdentifier(elementMetadata.value));
        this.#buildLazyPlanServiceNodeNodeFromClassElementMetadata =
            buildLazyPlanServiceNodeNodeFromClassElementMetadata;
        this.#params = params;
        this.#bindingConstraintsList = bindingConstraintsList;
        this.#elementMetadata = elementMetadata;
    }
    _buildPlanServiceNode() {
        return this.#buildLazyPlanServiceNodeNodeFromClassElementMetadata(this.#params, this.#bindingConstraintsList, this.#elementMetadata);
    }
}
class LazyResolvedValueMetadataPlanServiceNode extends LazyPlanServiceNode {
    #params;
    #buildLazyPlanServiceNodeNodeFromResolvedValueElementMetadata;
    #bindingConstraintsList;
    #resolvedValueElementMetadata;
    constructor(params, buildLazyPlanServiceNodeNodeFromResolvedValueElementMetadata, bindingConstraintsList, resolvedValueElementMetadata, serviceNode) {
        super(serviceNode, getServiceFromMaybeLazyServiceIdentifier(resolvedValueElementMetadata.value));
        this.#params = params;
        this.#buildLazyPlanServiceNodeNodeFromResolvedValueElementMetadata =
            buildLazyPlanServiceNodeNodeFromResolvedValueElementMetadata;
        this.#bindingConstraintsList = bindingConstraintsList;
        this.#resolvedValueElementMetadata = resolvedValueElementMetadata;
    }
    _buildPlanServiceNode() {
        return this.#buildLazyPlanServiceNodeNodeFromResolvedValueElementMetadata(this.#params, this.#bindingConstraintsList, this.#resolvedValueElementMetadata);
    }
}
function currySubplan(buildLazyPlanServiceNodeNodeFromClassElementMetadata, buildLazyPlanServiceNodeNodeFromResolvedValueElementMetadata, buildPlanServiceNodeFromClassElementMetadata, buildPlanServiceNodeFromResolvedValueElementMetadata) {
    const subplanInstanceBindingNode = currySubplanInstanceBindingNode(buildLazyPlanServiceNodeNodeFromClassElementMetadata, buildPlanServiceNodeFromClassElementMetadata);
    const subplanResolvedValueBindingNode = currySubplanResolvedValueBindingNode(buildLazyPlanServiceNodeNodeFromResolvedValueElementMetadata, buildPlanServiceNodeFromResolvedValueElementMetadata);
    return (params, bindingConstraintsList) => {
        if (isInstanceBindingNode(params.node)) {
            return subplanInstanceBindingNode(params, params.node, bindingConstraintsList);
        }
        else {
            return subplanResolvedValueBindingNode(params, params.node, bindingConstraintsList);
        }
    };
}
function currySubplanInstanceBindingNode(buildLazyPlanServiceNodeNodeFromClassElementMetadata, buildPlanServiceNodeFromClassElementMetadata) {
    const handlePlanServiceNodeBuildFromClassElementMetadata = curryHandlePlanServiceNodeBuildFromClassElementMetadata(buildLazyPlanServiceNodeNodeFromClassElementMetadata, buildPlanServiceNodeFromClassElementMetadata);
    return (params, node, bindingConstraintsList) => {
        const classMetadata = node.classMetadata;
        for (const [index, elementMetadata,] of classMetadata.constructorArguments.entries()) {
            node.constructorParams[index] =
                handlePlanServiceNodeBuildFromClassElementMetadata(params, bindingConstraintsList, elementMetadata);
        }
        for (const [propertyKey, elementMetadata] of classMetadata.properties) {
            const planServiceNode = handlePlanServiceNodeBuildFromClassElementMetadata(params, bindingConstraintsList, elementMetadata);
            if (planServiceNode !== undefined) {
                node.propertyParams.set(propertyKey, planServiceNode);
            }
        }
        return params.node;
    };
}
function currySubplanResolvedValueBindingNode(buildLazyPlanServiceNodeNodeFromResolvedValueElementMetadata, buildPlanServiceNodeFromResolvedValueElementMetadata) {
    const handlePlanServiceNodeBuildFromResolvedValueElementMetadata = curryHandlePlanServiceNodeBuildFromResolvedValueElementMetadata(buildLazyPlanServiceNodeNodeFromResolvedValueElementMetadata, buildPlanServiceNodeFromResolvedValueElementMetadata);
    return (params, node, bindingConstraintsList) => {
        const resolvedValueMetadata = node.binding.metadata;
        for (const [index, elementMetadata,] of resolvedValueMetadata.arguments.entries()) {
            node.params[index] =
                handlePlanServiceNodeBuildFromResolvedValueElementMetadata(params, bindingConstraintsList, elementMetadata);
        }
        return params.node;
    };
}
function curryHandlePlanServiceNodeBuildFromClassElementMetadata(buildLazyPlanServiceNodeNodeFromClassElementMetadata, buildPlanServiceNodeFromClassElementMetadata) {
    return (params, bindingConstraintsList, elementMetadata) => {
        if (elementMetadata.kind === ClassElementMetadataKind.unmanaged) {
            return undefined;
        }
        if (bindingConstraintsList.length > MAX_PLAN_DEPTH) {
            throw new InversifyCoreError(InversifyCoreErrorKind.planningMaxDepthExceeded, 'Maximum plan depth exceeded. This is likely caused by a circular dependency.');
        }
        const getPlanOptions = tryBuildGetPlanOptionsFromManagedClassElementMetadata(elementMetadata);
        if (getPlanOptions !== undefined) {
            const planResult = params.operations.getPlan(getPlanOptions);
            if (planResult !== undefined && planResult.tree.root.isContextFree) {
                return planResult.tree.root;
            }
        }
        const serviceNode = buildPlanServiceNodeFromClassElementMetadata(params, bindingConstraintsList, elementMetadata);
        const lazyPlanServiceNode = new LazyManagedClassMetadataPlanServiceNode(params, buildLazyPlanServiceNodeNodeFromClassElementMetadata, bindingConstraintsList, elementMetadata, serviceNode);
        cacheNonRootPlanServiceNode(getPlanOptions, params.operations, lazyPlanServiceNode, {
            bindingConstraintsList,
            chainedBindings: elementMetadata.kind === ClassElementMetadataKind.multipleInjection &&
                elementMetadata.chained,
            optionalBindings: elementMetadata.optional,
        });
        return lazyPlanServiceNode;
    };
}
function curryHandlePlanServiceNodeBuildFromResolvedValueElementMetadata(buildLazyPlanServiceNodeNodeFromResolvedValueElementMetadata, buildPlanServiceNodeFromResolvedValueElementMetadata) {
    return (params, bindingConstraintsList, elementMetadata) => {
        const getPlanOptions = tryBuildGetPlanOptionsFromResolvedValueElementMetadata(elementMetadata);
        if (getPlanOptions !== undefined) {
            const planResult = params.operations.getPlan(getPlanOptions);
            if (planResult !== undefined && planResult.tree.root.isContextFree) {
                return planResult.tree.root;
            }
        }
        const serviceNode = buildPlanServiceNodeFromResolvedValueElementMetadata(params, bindingConstraintsList, elementMetadata);
        const lazyPlanServiceNode = new LazyResolvedValueMetadataPlanServiceNode(params, buildLazyPlanServiceNodeNodeFromResolvedValueElementMetadata, bindingConstraintsList, elementMetadata, serviceNode);
        cacheNonRootPlanServiceNode(getPlanOptions, params.operations, lazyPlanServiceNode, {
            bindingConstraintsList,
            chainedBindings: elementMetadata.kind ===
                ResolvedValueElementMetadataKind.multipleInjection &&
                elementMetadata.chained,
            optionalBindings: elementMetadata.optional,
        });
        return lazyPlanServiceNode;
    };
}

class LazyRootPlanServiceNode extends LazyPlanServiceNode {
    #params;
    constructor(params, serviceNode) {
        super(serviceNode, serviceNode.serviceIdentifier);
        this.#params = params;
    }
    _buildPlanServiceNode() {
        return buildPlanServiceNode(this.#params);
    }
}
const buildPlanServiceNodeFromClassElementMetadata = curryBuildPlanServiceNodeFromClassElementMetadata(circularBuildServiceNodeBindings);
const buildPlanServiceNodeFromResolvedValueElementMetadata = curryBuildPlanServiceNodeFromResolvedValueElementMetadata(circularBuildServiceNodeBindings);
const subplan$1 = currySubplan(buildPlanServiceNodeFromClassElementMetadata, buildPlanServiceNodeFromResolvedValueElementMetadata, buildPlanServiceNodeFromClassElementMetadata, buildPlanServiceNodeFromResolvedValueElementMetadata);
const buildServiceNodeBindings$1 = curryBuildServiceNodeBindings(subplan$1);
function circularBuildServiceNodeBindings(params, bindingConstraintsList, serviceBindings, parentNode, chainedBindings) {
    return buildServiceNodeBindings$1(params, bindingConstraintsList, serviceBindings, parentNode, chainedBindings);
}
const buildPlanServiceNode = curryBuildPlanServiceNode(buildServiceNodeBindings$1);
function plan(params) {
    try {
        const getPlanOptions = buildGetPlanOptionsFromPlanParams(params);
        const planResultFromCache = params.operations.getPlan(getPlanOptions);
        if (planResultFromCache !== undefined) {
            return planResultFromCache;
        }
        const serviceNode = buildPlanServiceNode(params);
        const planResult = {
            tree: {
                root: new LazyRootPlanServiceNode(params, serviceNode),
            },
        };
        // Set the plan result in the cache no matter what, even if the plan is context dependent
        params.operations.setPlan(getPlanOptions, planResult);
        return planResult;
    }
    catch (error) {
        handlePlanError(params, error);
    }
}

var CacheBindingInvalidationKind;
(function (CacheBindingInvalidationKind) {
    CacheBindingInvalidationKind["bindingAdded"] = "bindingAdded";
    CacheBindingInvalidationKind["bindingRemoved"] = "bindingRemoved";
})(CacheBindingInvalidationKind || (CacheBindingInvalidationKind = {}));

const DEFAULT_MINIMUM_LENGTH_TO_REALLOCATE = 8;
const DEFAULT_MODULUS_TO_REALLOCATE_ON_PUSH = 1024;
const MIN_DEAD_REFS_FOR_REALLOCATION_PERCENTAGE = 0.5;
/**
 * A list-like collection that holds weak references to objects.
 * Automatically cleans up dead references when a threshold is met.
 *
 * FinalizationRegistry is not used here due to it's lack of determinism.
 * FinalizationRegsitry callbacks are not guaranteed to be called after an object is garbage collected.
 */
class WeakList {
    #list;
    #minimumLengthToReallocate;
    #modulusToReallocateOnPush;
    constructor() {
        this.#list = [];
        this.#minimumLengthToReallocate = DEFAULT_MINIMUM_LENGTH_TO_REALLOCATE;
        this.#modulusToReallocateOnPush = DEFAULT_MODULUS_TO_REALLOCATE_ON_PUSH;
    }
    *[Symbol.iterator]() {
        let deadRefCount = 0;
        for (const weakRef of this.#list) {
            const value = weakRef.deref();
            if (value === undefined) {
                ++deadRefCount;
            }
            else {
                yield value;
            }
        }
        if (this.#list.length >= this.#minimumLengthToReallocate &&
            this.#shouldReallocate(deadRefCount)) {
            this.#reallocate(deadRefCount);
        }
    }
    push(value) {
        const weakRef = new WeakRef(value);
        this.#list.push(weakRef);
        if (this.#list.length >= this.#minimumLengthToReallocate &&
            this.#list.length % this.#modulusToReallocateOnPush === 0) {
            let deadRefCount = 0;
            for (const ref of this.#list) {
                if (ref.deref() === undefined) {
                    ++deadRefCount;
                }
            }
            if (this.#shouldReallocate(deadRefCount)) {
                this.#reallocate(deadRefCount);
            }
        }
    }
    #reallocate(deadRefCount) {
        const newList = new Array(this.#list.length - deadRefCount);
        let i = 0;
        for (const ref of this.#list) {
            if (ref.deref()) {
                newList[i++] = ref;
            }
        }
        this.#list = newList;
    }
    #shouldReallocate(deadRefCount) {
        return (deadRefCount >=
            this.#list.length * MIN_DEAD_REFS_FOR_REALLOCATION_PERCENTAGE);
    }
}

function curryLazyBuildPlanServiceNodeFromClassElementMetadata(buildServiceNodeBindings) {
    const buildPlanServiceNodeFromClassElementMetadata = curryBuildPlanServiceNodeFromClassElementMetadata(buildServiceNodeBindings);
    return (params, bindingConstraintsList, elementMetadata) => {
        try {
            return buildPlanServiceNodeFromClassElementMetadata(params, bindingConstraintsList, elementMetadata);
        }
        catch (error) {
            if (InversifyCoreError.isErrorOfKind(error, InversifyCoreErrorKind.planning)) {
                return undefined;
            }
            throw error;
        }
    };
}

function curryLazyBuildPlanServiceNodeFromResolvedValueElementMetadata(buildServiceNodeBindings) {
    const buildPlanServiceNodeFromResolvedValueElementMetadata = curryBuildPlanServiceNodeFromResolvedValueElementMetadata(buildServiceNodeBindings);
    return (params, bindingConstraintsList, elementMetadata) => {
        try {
            return buildPlanServiceNodeFromResolvedValueElementMetadata(params, bindingConstraintsList, elementMetadata);
        }
        catch (error) {
            if (InversifyCoreError.isErrorOfKind(error, InversifyCoreErrorKind.planning)) {
                return undefined;
            }
            throw error;
        }
    };
}

const subplan = currySubplan(buildPlanServiceNodeFromClassElementMetadata, buildPlanServiceNodeFromResolvedValueElementMetadata, circularLazyBuildPlanServiceNodeFromClassElementMetadata, circularLazyBuildPlanServiceNodeFromResolvedValueElementMetadata);
const buildServiceNodeBindings = curryBuildServiceNodeBindings(subplan);
const lazyBuildPlanServiceNodeFromClassElementMetadata = curryLazyBuildPlanServiceNodeFromClassElementMetadata(buildServiceNodeBindings);
const lazyBuildPlanServiceNodeFromResolvedValueElementMetadata = curryLazyBuildPlanServiceNodeFromResolvedValueElementMetadata(buildServiceNodeBindings);
function circularLazyBuildPlanServiceNodeFromClassElementMetadata(params, bindingConstraintsList, elementMetadata) {
    return lazyBuildPlanServiceNodeFromClassElementMetadata(params, bindingConstraintsList, elementMetadata);
}
function circularLazyBuildPlanServiceNodeFromResolvedValueElementMetadata(params, bindingConstraintsList, elementMetadata) {
    return lazyBuildPlanServiceNodeFromResolvedValueElementMetadata(params, bindingConstraintsList, elementMetadata);
}
/**
 * Attach a binding to a service node if the binding is context-free.
 * @param params The plan parameters.
 * @param serviceNode The service node to attach the binding to.
 * @param binding The binding to attach.
 * @param bindingConstraintsList The list of binding constraints.
 * @param chainedBindings Whether the bindings are chained.
 * @returns True if the binding requires ancestor metadata, false otherwise.
 */
function addServiceNodeBindingIfContextFree(params, serviceNode, binding, bindingConstraintsList, chainedBindings) {
    if (LazyPlanServiceNode.is(serviceNode) && !serviceNode.isExpanded()) {
        return {
            isContextFreeBinding: true,
            shouldInvalidateServiceNode: false,
        };
    }
    const bindingConstraints = new BindingConstraintsImplementation(bindingConstraintsList.last);
    if (!binding.isSatisfiedBy(bindingConstraints) ||
        bindingConstraintsList.last.elem.getAncestorsCalled) {
        return {
            isContextFreeBinding: !bindingConstraintsList.last.elem.getAncestorsCalled,
            shouldInvalidateServiceNode: false,
        };
    }
    return addServiceNodeSatisfiedBindingIfContextFree(params, serviceNode, binding, bindingConstraintsList, chainedBindings);
}
function addServiceNodeSatisfiedBindingIfContextFree(params, serviceNode, binding, bindingConstraintsList, chainedBindings) {
    let serviceNodeBinding;
    try {
        [serviceNodeBinding] = buildServiceNodeBindings(params, bindingConstraintsList, [binding], serviceNode, chainedBindings);
    }
    catch (error) {
        if (isStackOverflowError(error) ||
            InversifyCoreError.isErrorOfKind(error, InversifyCoreErrorKind.planningMaxDepthExceeded)) {
            /**
             * We could potentially detect if we managed to traverse at least one iteration of the circular dependency loop.
             * If so, the binding is context free if and only if bindingConstraintsList.last.elem.getAncestorsCalled is false.
             *
             * Having said that, computing this does not solve an underlying issue with circular dependencies: further cache
             * refreshes are likely to encounter the same issue again and again. Recovering from stack overflow errors constantly
             * is not feasible, so we prefer to declare the binding as non context free, asking for a more aggressive cache
             * invalidation strategy, which is likely to be a cache clear.
             */
            return {
                isContextFreeBinding: false,
                shouldInvalidateServiceNode: true,
            };
        }
        throw error;
    }
    return addServiceNodeBindingNodeIfContextFree(serviceNode, serviceNodeBinding);
}
function addServiceNodeBindingNodeIfContextFree(serviceNode, serviceNodeBinding) {
    if (Array.isArray(serviceNode.bindings)) {
        serviceNode.bindings.push(serviceNodeBinding);
    }
    else {
        if (serviceNode.bindings === undefined) {
            serviceNode.bindings = serviceNodeBinding;
        }
        else {
            if (!LazyPlanServiceNode.is(serviceNode)) {
                throw new InversifyCoreError(InversifyCoreErrorKind.planning, 'Unexpected non-lazy plan service node. This is likely a bug in the planning logic. Please, report this issue');
            }
            return {
                isContextFreeBinding: true,
                shouldInvalidateServiceNode: true,
            };
        }
    }
    return {
        isContextFreeBinding: true,
        shouldInvalidateServiceNode: false,
    };
}

/**
 * Attach a binding to the root service node if the binding is context-free.
 * @param params The plan parameters.
 * @param serviceNode The service node to attach the binding to.
 * @param binding The binding to attach.
 * @returns True if the binding requires ancestor metadata, false otherwise.
 */
function addRootServiceNodeBindingIfContextFree(params, serviceNode, binding) {
    if (LazyPlanServiceNode.is(serviceNode) && !serviceNode.isExpanded()) {
        return {
            isContextFreeBinding: true,
            shouldInvalidateServiceNode: false,
        };
    }
    const bindingConstraintsList = buildPlanBindingConstraintsList(params);
    const chained = params.rootConstraints.isMultiple && params.rootConstraints.chained;
    return addServiceNodeBindingIfContextFree(params, serviceNode, binding, bindingConstraintsList, chained);
}

/**
 * Detach a binding to the root service node if it is context-free.
 * @param serviceNode The service node to attach the binding to.
 * @param binding The binding to attach.
 * @param bindingConstraintsList The list of binding constraints.
 * @param optionalBindings Whether the bindings are optional.
 * @returns True if the binding requires ancestor metadata, false otherwise.
 */
function removeServiceNodeBindingIfContextFree(serviceNode, binding, bindingConstraintsList, optionalBindings) {
    if (LazyPlanServiceNode.is(serviceNode) && !serviceNode.isExpanded()) {
        return {
            bindingNodeRemoved: undefined,
            isContextFreeBinding: true,
        };
    }
    const bindingConstraints = new BindingConstraintsImplementation(bindingConstraintsList.last);
    if (!binding.isSatisfiedBy(bindingConstraints) ||
        bindingConstraintsList.last.elem.getAncestorsCalled) {
        return {
            bindingNodeRemoved: undefined,
            isContextFreeBinding: !bindingConstraintsList.last.elem.getAncestorsCalled,
        };
    }
    let bindingNodeRemoved;
    if (Array.isArray(serviceNode.bindings)) {
        serviceNode.bindings = serviceNode.bindings.filter((bindingNode) => {
            if (bindingNode.binding === binding) {
                bindingNodeRemoved = bindingNode;
                return false;
            }
            return true;
        });
    }
    else {
        if (serviceNode.bindings?.binding === binding) {
            bindingNodeRemoved = serviceNode.bindings;
            if (optionalBindings) {
                serviceNode.bindings = undefined;
            }
            else {
                if (!LazyPlanServiceNode.is(serviceNode)) {
                    throw new InversifyCoreError(InversifyCoreErrorKind.planning, 'Unexpected non-lazy plan service node. This is likely a bug in the planning logic. Please, report this issue');
                }
                serviceNode.invalidate();
            }
        }
    }
    return {
        bindingNodeRemoved: bindingNodeRemoved,
        isContextFreeBinding: true,
    };
}

/**
 * Detach a binding to the root service node if it is context-free.
 * @param params The plan parameters.
 * @param serviceNode The service node to attach the binding to.
 * @param binding The binding to attach.
 * @returns True if the binding requires ancestor metadata, false otherwise.
 */
function removeRootServiceNodeBindingIfContextFree(params, serviceNode, binding) {
    if (LazyPlanServiceNode.is(serviceNode) && !serviceNode.isExpanded()) {
        return {
            bindingNodeRemoved: undefined,
            isContextFreeBinding: true,
        };
    }
    const bindingConstraintsList = buildPlanBindingConstraintsList(params);
    return removeServiceNodeBindingIfContextFree(serviceNode, binding, bindingConstraintsList, params.rootConstraints.isOptional ?? false);
}

const CHAINED_MASK = 0x4;
const IS_MULTIPLE_MASK = 0x2;
const OPTIONAL_MASK = 0x1;
const MAP_ARRAY_LENGTH = 0x8;
/**
 * Service to cache plans.
 *
 * This class is used to cache plans and to notify PlanService subscribers when the cache is cleared.
 * The cache should be cleared when a new binding is registered or when a binding is unregistered.
 *
 * Subscribers are supposed to be plan services from child containers.
 *
 * Ancestor binding constraints are the reason to avoid reusing plans from plan children nodes.
 */
class PlanResultCacheService {
    #serviceIdToNonCachedServiceNodeMapMap;
    #serviceIdToValuePlanMap;
    #namedServiceIdToValuePlanMap;
    #namedTaggedServiceIdToValuePlanMap;
    #taggedServiceIdToValuePlanMap;
    #subscribers;
    constructor() {
        this.#serviceIdToNonCachedServiceNodeMapMap = new Map();
        this.#serviceIdToValuePlanMap = this.#buildInitializedMapArray();
        this.#namedServiceIdToValuePlanMap = this.#buildInitializedMapArray();
        this.#namedTaggedServiceIdToValuePlanMap = this.#buildInitializedMapArray();
        this.#taggedServiceIdToValuePlanMap = this.#buildInitializedMapArray();
        this.#subscribers = new WeakList();
    }
    clearCache() {
        for (const map of this.#getMaps()) {
            map.clear();
        }
        for (const subscriber of this.#subscribers) {
            subscriber.clearCache();
        }
    }
    get(options) {
        if (options.name === undefined) {
            if (options.tag === undefined) {
                return this.#getMapFromMapArray(this.#serviceIdToValuePlanMap, options).get(options.serviceIdentifier);
            }
            else {
                return this.#getMapFromMapArray(this.#taggedServiceIdToValuePlanMap, options)
                    .get(options.serviceIdentifier)
                    ?.get(options.tag.key)
                    ?.get(options.tag.value);
            }
        }
        else {
            if (options.tag === undefined) {
                return this.#getMapFromMapArray(this.#namedServiceIdToValuePlanMap, options)
                    .get(options.serviceIdentifier)
                    ?.get(options.name);
            }
            else {
                return this.#getMapFromMapArray(this.#namedTaggedServiceIdToValuePlanMap, options)
                    .get(options.serviceIdentifier)
                    ?.get(options.name)
                    ?.get(options.tag.key)
                    ?.get(options.tag.value);
            }
        }
    }
    invalidateServiceBinding(invalidation) {
        this.#invalidateServiceMap(invalidation);
        this.#invalidateNamedServiceMap(invalidation);
        this.#invalidateNamedTaggedServiceMap(invalidation);
        this.#invalidateTaggedServiceMap(invalidation);
        this.#invalidateNonCachedServiceNodeSetMap(invalidation);
        for (const subscriber of this.#subscribers) {
            subscriber.invalidateServiceBinding(invalidation);
        }
    }
    set(options, planResult) {
        if (options.name === undefined) {
            if (options.tag === undefined) {
                this.#getMapFromMapArray(this.#serviceIdToValuePlanMap, options).set(options.serviceIdentifier, planResult);
            }
            else {
                this.#getOrBuildMapValueFromMapMap(this.#getOrBuildMapValueFromMapMap(this.#getMapFromMapArray(this.#taggedServiceIdToValuePlanMap, options), options.serviceIdentifier), options.tag.key).set(options.tag.value, planResult);
            }
        }
        else {
            if (options.tag === undefined) {
                this.#getOrBuildMapValueFromMapMap(this.#getMapFromMapArray(this.#namedServiceIdToValuePlanMap, options), options.serviceIdentifier).set(options.name, planResult);
            }
            else {
                this.#getOrBuildMapValueFromMapMap(this.#getOrBuildMapValueFromMapMap(this.#getOrBuildMapValueFromMapMap(this.#getMapFromMapArray(this.#namedTaggedServiceIdToValuePlanMap, options), options.serviceIdentifier), options.name), options.tag.key).set(options.tag.value, planResult);
            }
        }
    }
    setNonCachedServiceNode(node, context) {
        let nonCachedMap = this.#serviceIdToNonCachedServiceNodeMapMap.get(node.serviceIdentifier);
        if (nonCachedMap === undefined) {
            nonCachedMap = new Map();
            this.#serviceIdToNonCachedServiceNodeMapMap.set(node.serviceIdentifier, nonCachedMap);
        }
        nonCachedMap.set(node, context);
    }
    subscribe(subscriber) {
        this.#subscribers.push(subscriber);
    }
    #buildInitializedMapArray() {
        const mapArray = new Array(MAP_ARRAY_LENGTH);
        for (let i = 0; i < mapArray.length; ++i) {
            mapArray[i] = new Map();
        }
        return mapArray;
    }
    #buildUpdatePlanParams(invalidation, index, name, tag) {
        const isMultiple = (index & IS_MULTIPLE_MASK) !== 0;
        let planParamsConstraint;
        if (isMultiple) {
            const isChained = (index & IS_MULTIPLE_MASK & CHAINED_MASK) !== 0;
            planParamsConstraint = {
                chained: isChained,
                isMultiple,
                serviceIdentifier: invalidation.binding.serviceIdentifier,
            };
        }
        else {
            planParamsConstraint = {
                isMultiple,
                serviceIdentifier: invalidation.binding.serviceIdentifier,
            };
        }
        const isOptional = (index & OPTIONAL_MASK) !== 0;
        if (isOptional) {
            planParamsConstraint.isOptional = true;
        }
        if (name !== undefined) {
            planParamsConstraint.name = name;
        }
        if (tag !== undefined) {
            planParamsConstraint.tag = tag;
        }
        return {
            autobindOptions: undefined,
            operations: invalidation.operations,
            rootConstraints: planParamsConstraint,
            servicesBranch: [],
        };
    }
    #getOrBuildMapValueFromMapMap(map, key) {
        let valueMap = map.get(key);
        if (valueMap === undefined) {
            valueMap = new Map();
            map.set(key, valueMap);
        }
        return valueMap;
    }
    #getMapFromMapArray(mapArray, options) {
        return mapArray[this.#getMapArrayIndex(options)];
    }
    #getMaps() {
        return [
            this.#serviceIdToNonCachedServiceNodeMapMap,
            ...this.#serviceIdToValuePlanMap,
            ...this.#namedServiceIdToValuePlanMap,
            ...this.#namedTaggedServiceIdToValuePlanMap,
            ...this.#taggedServiceIdToValuePlanMap,
        ];
    }
    #getMapArrayIndex(options) {
        if (options.isMultiple) {
            return ((options.chained ? CHAINED_MASK : 0) |
                (options.optional ? OPTIONAL_MASK : 0) |
                IS_MULTIPLE_MASK);
        }
        else {
            return options.optional ? OPTIONAL_MASK : 0;
        }
    }
    #invalidateNamedServiceMap(invalidation) {
        for (const [index, map] of this.#namedServiceIdToValuePlanMap.entries()) {
            const servicePlans = map.get(invalidation.binding.serviceIdentifier);
            if (servicePlans !== undefined) {
                for (const [name, servicePlan] of servicePlans.entries()) {
                    this.#updatePlan(invalidation, servicePlan, index, name, undefined);
                }
            }
        }
    }
    #invalidateNamedTaggedServiceMap(invalidation) {
        for (const [index, map,] of this.#namedTaggedServiceIdToValuePlanMap.entries()) {
            const servicePlanMapMapMap = map.get(invalidation.binding.serviceIdentifier);
            if (servicePlanMapMapMap !== undefined) {
                for (const [name, servicePlanMapMap,] of servicePlanMapMapMap.entries()) {
                    for (const [tag, servicePlanMap] of servicePlanMapMap.entries()) {
                        for (const [tagValue, servicePlan] of servicePlanMap.entries()) {
                            this.#updatePlan(invalidation, servicePlan, index, name, {
                                key: tag,
                                value: tagValue,
                            });
                        }
                    }
                }
            }
        }
    }
    #invalidateNonCachePlanBindingNodeDescendents(planBindingNode) {
        switch (planBindingNode.binding.type) {
            case bindingTypeValues.ServiceRedirection:
                for (const redirection of planBindingNode.redirections) {
                    this.#invalidateNonCachePlanBindingNodeDescendents(redirection);
                }
                break;
            case bindingTypeValues.Instance:
                for (const constructorParam of planBindingNode
                    .constructorParams) {
                    if (constructorParam !== undefined) {
                        this.#invalidateNonCachePlanServiceNode(constructorParam);
                    }
                }
                for (const propertyParam of planBindingNode.propertyParams.values()) {
                    this.#invalidateNonCachePlanServiceNode(propertyParam);
                }
                break;
            case bindingTypeValues.ResolvedValue:
                for (const resolvedValue of planBindingNode.params) {
                    this.#invalidateNonCachePlanServiceNode(resolvedValue);
                }
                break;
        }
    }
    #invalidateNonCachePlanServiceNode(planServiceNode) {
        const serviceNonCachedMap = this.#serviceIdToNonCachedServiceNodeMapMap.get(planServiceNode.serviceIdentifier);
        if (serviceNonCachedMap === undefined ||
            !serviceNonCachedMap.has(planServiceNode)) {
            return;
        }
        serviceNonCachedMap.delete(planServiceNode);
        this.#invalidateNonCachePlanServiceNodeDescendents(planServiceNode);
    }
    #invalidateNonCachePlanServiceNodeDescendents(planServiceNode) {
        if (LazyPlanServiceNode.is(planServiceNode) &&
            !planServiceNode.isExpanded()) {
            return;
        }
        if (planServiceNode.bindings === undefined) {
            return;
        }
        if (Array.isArray(planServiceNode.bindings)) {
            for (const binding of planServiceNode.bindings) {
                this.#invalidateNonCachePlanBindingNodeDescendents(binding);
            }
        }
        else {
            this.#invalidateNonCachePlanBindingNodeDescendents(planServiceNode.bindings);
        }
    }
    #invalidateNonCachedServiceNodeSetMap(invalidation) {
        const serviceNonCachedServiceNodeMap = this.#serviceIdToNonCachedServiceNodeMapMap.get(invalidation.binding.serviceIdentifier);
        if (serviceNonCachedServiceNodeMap !== undefined) {
            switch (invalidation.kind) {
                case CacheBindingInvalidationKind.bindingAdded:
                    for (const [serviceNode, context] of serviceNonCachedServiceNodeMap) {
                        const result = addServiceNodeBindingIfContextFree({
                            autobindOptions: undefined,
                            operations: invalidation.operations,
                            servicesBranch: [],
                        }, serviceNode, invalidation.binding, context.bindingConstraintsList, context.chainedBindings);
                        if (result.isContextFreeBinding) {
                            if (result.shouldInvalidateServiceNode &&
                                LazyPlanServiceNode.is(serviceNode)) {
                                this.#invalidateNonCachePlanServiceNodeDescendents(serviceNode);
                                serviceNode.invalidate();
                            }
                        }
                        else {
                            this.clearCache();
                        }
                    }
                    break;
                case CacheBindingInvalidationKind.bindingRemoved:
                    for (const [serviceNode, context] of serviceNonCachedServiceNodeMap) {
                        const result = removeServiceNodeBindingIfContextFree(serviceNode, invalidation.binding, context.bindingConstraintsList, context.optionalBindings);
                        if (result.isContextFreeBinding) {
                            if (result.bindingNodeRemoved !== undefined) {
                                this.#invalidateNonCachePlanBindingNodeDescendents(result.bindingNodeRemoved);
                            }
                        }
                        else {
                            this.clearCache();
                        }
                    }
                    break;
            }
        }
    }
    #invalidateServiceMap(invalidation) {
        for (const [index, map] of this.#serviceIdToValuePlanMap.entries()) {
            const servicePlan = map.get(invalidation.binding.serviceIdentifier);
            this.#updatePlan(invalidation, servicePlan, index, undefined, undefined);
        }
    }
    #invalidateTaggedServiceMap(invalidation) {
        for (const [index, map] of this.#taggedServiceIdToValuePlanMap.entries()) {
            const servicePlanMapMap = map.get(invalidation.binding.serviceIdentifier);
            if (servicePlanMapMap !== undefined) {
                for (const [tag, servicePlanMap] of servicePlanMapMap.entries()) {
                    for (const [tagValue, servicePlan] of servicePlanMap.entries()) {
                        this.#updatePlan(invalidation, servicePlan, index, undefined, {
                            key: tag,
                            value: tagValue,
                        });
                    }
                }
            }
        }
    }
    #updatePlan(invalidation, servicePlan, index, name, tag) {
        if (servicePlan !== undefined &&
            LazyPlanServiceNode.is(servicePlan.tree.root)) {
            const planParams = this.#buildUpdatePlanParams(invalidation, index, name, tag);
            switch (invalidation.kind) {
                case CacheBindingInvalidationKind.bindingAdded:
                    {
                        const result = addRootServiceNodeBindingIfContextFree(planParams, servicePlan.tree.root, invalidation.binding);
                        if (result.isContextFreeBinding) {
                            if (result.shouldInvalidateServiceNode) {
                                this.#invalidateNonCachePlanServiceNodeDescendents(servicePlan.tree.root);
                                servicePlan.tree.root.invalidate();
                            }
                        }
                        else {
                            this.clearCache();
                        }
                    }
                    break;
                case CacheBindingInvalidationKind.bindingRemoved:
                    {
                        const result = removeRootServiceNodeBindingIfContextFree(planParams, servicePlan.tree.root, invalidation.binding);
                        if (result.isContextFreeBinding) {
                            if (result.bindingNodeRemoved !== undefined) {
                                this.#invalidateNonCachePlanBindingNodeDescendents(result.bindingNodeRemoved);
                            }
                        }
                        else {
                            this.clearCache();
                        }
                    }
                    break;
            }
        }
    }
}

const INDEX_NOT_FOUND = -1;
function handleResolveError(params, error) {
    if (isStackOverflowError(error) ||
        InversifyCoreError.isErrorOfKind(error, InversifyCoreErrorKind.planningMaxDepthExceeded)) {
        const stringifiedCircularDependencies = stringifyServiceIdentifierTrace(extractLikelyCircularDependency(params));
        throw new InversifyCoreError(InversifyCoreErrorKind.planning, `Circular dependency found: ${stringifiedCircularDependencies}`, { cause: error });
    }
    throw error;
}
function extractLikelyCircularDependency(params) {
    const root = params.planResult.tree.root;
    const stack = [];
    function depthFirstSearch(node) {
        const existingIndex = stack.indexOf(node);
        if (existingIndex !== INDEX_NOT_FOUND) {
            const cycleNodes = [
                ...stack.slice(existingIndex),
                node,
            ];
            return cycleNodes.map((n) => n.serviceIdentifier);
        }
        stack.push(node);
        try {
            for (const child of getChildServiceNodes(node)) {
                const result = depthFirstSearch(child);
                if (result !== undefined) {
                    return result;
                }
            }
        }
        finally {
            stack.pop();
        }
        return undefined;
    }
    const result = depthFirstSearch(root);
    return result ?? [];
}
function getChildServiceNodes(serviceNode) {
    const children = [];
    const bindings = serviceNode.bindings;
    if (bindings === undefined) {
        return children;
    }
    const processBindingNode = (bindingNode) => {
        if (isPlanServiceRedirectionBindingNode(bindingNode)) {
            for (const redirection of bindingNode.redirections) {
                processBindingNode(redirection);
            }
            return;
        }
        switch (bindingNode.binding.type) {
            case bindingTypeValues.Instance: {
                const instanceNode = bindingNode;
                for (const ctorParam of instanceNode.constructorParams) {
                    if (ctorParam !== undefined) {
                        children.push(ctorParam);
                    }
                }
                for (const propParam of instanceNode.propertyParams.values()) {
                    children.push(propParam);
                }
                break;
            }
            case bindingTypeValues.ResolvedValue: {
                const resolvedValueNode = bindingNode;
                for (const param of resolvedValueNode.params) {
                    children.push(param);
                }
                break;
            }
        }
    };
    if (Array.isArray(bindings)) {
        for (const bindingNode of bindings) {
            processBindingNode(bindingNode);
        }
    }
    else {
        processBindingNode(bindings);
    }
    return children;
}
function stringifyServiceIdentifierTrace(serviceIdentifiers) {
    const serviceIdentifiersArray = [...serviceIdentifiers];
    if (serviceIdentifiersArray.length === 0) {
        return '(No dependency trace)';
    }
    return serviceIdentifiersArray.map(stringifyServiceIdentifier).join(' -> ');
}

function resolveConstantValueBindingCallback(_params, binding) {
    return binding.value;
}

function cacheResolvedValue(binding, resolvedValue) {
    if (isPromise(resolvedValue)) {
        binding.cache = {
            isRight: true,
            value: resolvedValue,
        };
        return resolvedValue.then((syncResolvedValue) => cacheSyncResolvedValue(binding, syncResolvedValue));
    }
    return cacheSyncResolvedValue(binding, resolvedValue);
}
function cacheSyncResolvedValue(binding, resolvedValue) {
    binding.cache = {
        isRight: true,
        value: resolvedValue,
    };
    return resolvedValue;
}

function resolveBindingServiceActivations(params, serviceIdentifier, value) {
    const activations = params.getActivations(serviceIdentifier);
    if (activations === undefined) {
        return value;
    }
    if (isPromise(value)) {
        return resolveBindingActivationsFromIteratorAsync(params, value, activations[Symbol.iterator]());
    }
    return resolveBindingActivationsFromIterator(params, value, activations[Symbol.iterator]());
}
function resolveBindingActivationsFromIterator(params, value, activationsIterator) {
    let activatedValue = value;
    let activationIteratorResult = activationsIterator.next();
    while (activationIteratorResult.done !== true) {
        const nextActivatedValue = activationIteratorResult.value(params.context, activatedValue);
        if (isPromise(nextActivatedValue)) {
            return resolveBindingActivationsFromIteratorAsync(params, nextActivatedValue, activationsIterator);
        }
        else {
            activatedValue = nextActivatedValue;
        }
        activationIteratorResult = activationsIterator.next();
    }
    return activatedValue;
}
async function resolveBindingActivationsFromIteratorAsync(params, value, activationsIterator) {
    let activatedValue = await value;
    let activationIteratorResult = activationsIterator.next();
    while (activationIteratorResult.done !== true) {
        activatedValue = await activationIteratorResult.value(params.context, activatedValue);
        activationIteratorResult = activationsIterator.next();
    }
    return activatedValue;
}

function resolveBindingActivations(params, binding, value) {
    let activationResult = value;
    if (binding.onActivation !== undefined) {
        const onActivation = binding.onActivation;
        if (isPromise(activationResult)) {
            activationResult = activationResult.then((resolved) => onActivation(params.context, resolved));
        }
        else {
            activationResult = onActivation(params.context, activationResult);
        }
    }
    return resolveBindingServiceActivations(params, binding.serviceIdentifier, activationResult);
}

function resolveSingletonScopedBinding(resolve) {
    return (params, binding) => {
        if (binding.cache.isRight) {
            return binding.cache.value;
        }
        const resolvedValue = resolveBindingActivations(params, binding, resolve(params, binding));
        return cacheResolvedValue(binding, resolvedValue);
    };
}

const resolveConstantValueBinding = resolveSingletonScopedBinding(resolveConstantValueBindingCallback);

function resolveDynamicValueBindingCallback(params, binding) {
    return binding.value(params.context);
}

function getSelf(self) {
    return self;
}

function resolveScoped(getBinding, resolve) {
    return (params, arg) => {
        const binding = getBinding(arg);
        switch (binding.scope) {
            case bindingScopeValues.Singleton: {
                if (binding.cache.isRight) {
                    return binding.cache.value;
                }
                const resolvedValue = resolveBindingActivations(params, binding, resolve(params, arg));
                return cacheResolvedValue(binding, resolvedValue);
            }
            case bindingScopeValues.Request: {
                if (params.requestScopeCache.has(binding.id)) {
                    return params.requestScopeCache.get(binding.id);
                }
                const resolvedValue = resolveBindingActivations(params, binding, resolve(params, arg));
                params.requestScopeCache.set(binding.id, resolvedValue);
                return resolvedValue;
            }
            case bindingScopeValues.Transient:
                return resolveBindingActivations(params, binding, resolve(params, arg));
        }
    };
}

const resolveScopedBinding = (resolve) => resolveScoped(getSelf, resolve);

const resolveDynamicValueBinding = resolveScopedBinding(resolveDynamicValueBindingCallback);

function resolveFactoryBindingCallback(params, binding) {
    return binding.factory(params.context);
}

const resolveFactoryBinding = resolveSingletonScopedBinding(resolveFactoryBindingCallback);

function resolveInstanceBindingConstructorParams(resolveServiceNode) {
    return (params, node) => {
        const constructorResolvedValues = [];
        for (const constructorParam of node.constructorParams) {
            if (constructorParam === undefined) {
                constructorResolvedValues.push(undefined);
            }
            else {
                constructorResolvedValues.push(resolveServiceNode(params, constructorParam));
            }
        }
        return constructorResolvedValues.some(isPromise)
            ? Promise.all(constructorResolvedValues)
            : constructorResolvedValues;
    };
}

function resolveInstanceBindingNode$1(resolveInstanceBindingConstructorParams, resolveInstanceBindingNodeAsyncFromConstructorParams, resolveInstanceBindingNodeFromConstructorParams) {
    return (params, node) => {
        const constructorValues = resolveInstanceBindingConstructorParams(params, node);
        if (isPromise(constructorValues)) {
            return resolveInstanceBindingNodeAsyncFromConstructorParams(constructorValues, params, node);
        }
        return resolveInstanceBindingNodeFromConstructorParams(constructorValues, params, node);
    };
}

function resolveInstanceBindingNodeAsyncFromConstructorParams(resolveInstanceBindingNodeFromConstructorParams) {
    return async (constructorValues, params, node) => {
        const constructorResolvedValues = await constructorValues;
        return resolveInstanceBindingNodeFromConstructorParams(constructorResolvedValues, params, node);
    };
}

function resolvePostConstruct(instance, binding, postConstructMethodName) {
    const postConstructResult = invokePostConstruct(instance, binding, postConstructMethodName);
    if (isPromise(postConstructResult)) {
        return postConstructResult.then(() => instance);
    }
    return instance;
}
function invokePostConstruct(instance, binding, postConstructMethodName) {
    if (postConstructMethodName in instance) {
        if (typeof instance[postConstructMethodName] === 'function') {
            let postConstructResult;
            try {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                postConstructResult = instance[postConstructMethodName]();
            }
            catch (error) {
                throw new InversifyCoreError(InversifyCoreErrorKind.resolution, `Unexpected error found when calling "${postConstructMethodName.toString()}" @postConstruct decorated method on class "${binding.implementationType.name}"`, {
                    cause: error,
                });
            }
            if (isPromise(postConstructResult)) {
                return invokePostConstructAsync(binding, postConstructMethodName, postConstructResult);
            }
        }
        else {
            throw new InversifyCoreError(InversifyCoreErrorKind.resolution, `Expecting a "${postConstructMethodName.toString()}" method when resolving "${binding.implementationType.name}" class @postConstruct decorated method, a non function property was found instead.`);
        }
    }
    else {
        throw new InversifyCoreError(InversifyCoreErrorKind.resolution, `Expecting a "${postConstructMethodName.toString()}" property when resolving "${binding.implementationType.name}" class @postConstruct decorated method, none found.`);
    }
}
async function invokePostConstructAsync(binding, postConstructMethodName, postConstructResult) {
    try {
        await postConstructResult;
    }
    catch (error) {
        throw new InversifyCoreError(InversifyCoreErrorKind.resolution, `Unexpected error found when calling "${postConstructMethodName.toString()}" @postConstruct decorated method on class "${binding.implementationType.name}"`, {
            cause: error,
        });
    }
}

function resolveAllPostConstructMethods(instance, binding, postConstructMethodNames) {
    if (postConstructMethodNames.size === 0) {
        return instance;
    }
    let result = instance;
    for (const methodName of postConstructMethodNames) {
        if (isPromise(result)) {
            result = result.then((resolvedInstance) => resolvePostConstruct(resolvedInstance, binding, methodName));
        }
        else {
            result = resolvePostConstruct(result, binding, methodName);
        }
    }
    return result;
}
function resolveInstanceBindingNodeFromConstructorParams(setInstanceProperties) {
    return (constructorValues, params, node) => {
        const instance = new node.binding.implementationType(...constructorValues);
        const propertiesAssignmentResult = setInstanceProperties(params, instance, node);
        if (isPromise(propertiesAssignmentResult)) {
            return propertiesAssignmentResult.then(() => resolveAllPostConstructMethods(instance, node.binding, node.classMetadata.lifecycle.postConstructMethodNames));
        }
        return resolveAllPostConstructMethods(instance, node.binding, node.classMetadata.lifecycle.postConstructMethodNames);
    };
}

function resolveResolvedValueBindingNode$1(resolveResolvedValueBindingParams) {
    return (params, node) => {
        const paramValues = resolveResolvedValueBindingParams(params, node);
        if (isPromise(paramValues)) {
            return paramValues.then((resolvedParamValues) => node.binding.factory(...resolvedParamValues));
        }
        return node.binding.factory(...paramValues);
    };
}

function resolveResolvedValueBindingParams(resolveServiceNode) {
    return (params, node) => {
        const paramsResolvedValues = [];
        for (const param of node.params) {
            paramsResolvedValues.push(resolveServiceNode(params, param));
        }
        return paramsResolvedValues.some(isPromise)
            ? Promise.all(paramsResolvedValues)
            : paramsResolvedValues;
    };
}

function getInstanceNodeBinding(node) {
    return node.binding;
}

const resolveScopedInstanceBindingNode$1 = (resolve) => resolveScoped(getInstanceNodeBinding, resolve);

function getResolvedValueNodeBinding(node) {
    return node.binding;
}

const resolveScopedResolvedValueBindingNode$1 = (resolve) => resolveScoped(getResolvedValueNodeBinding, resolve);

function resolveServiceRedirectionBindingNode$1(resolveBindingNode) {
    function innerResolveServiceRedirectionBindingNode(params, node) {
        const resolvedValues = [];
        for (const redirection of node.redirections) {
            if (isPlanServiceRedirectionBindingNode(redirection)) {
                resolvedValues.push(...innerResolveServiceRedirectionBindingNode(params, redirection));
            }
            else {
                resolvedValues.push(resolveBindingNode(params, redirection));
            }
        }
        return resolvedValues;
    }
    return innerResolveServiceRedirectionBindingNode;
}

function setInstanceProperties$1(resolveServiceNode) {
    return (params, instance, node) => {
        const propertyAssignmentPromises = [];
        for (const [propertyKey, propertyNode] of node.propertyParams) {
            const metadata = node.classMetadata.properties.get(propertyKey);
            if (metadata === undefined) {
                throw new InversifyCoreError(InversifyCoreErrorKind.resolution, `Expecting metadata at property "${propertyKey.toString()}", none found`);
            }
            if (metadata.kind !== ClassElementMetadataKind.unmanaged &&
                propertyNode.bindings !== undefined) {
                instance[propertyKey] = resolveServiceNode(params, propertyNode);
                if (isPromise(instance[propertyKey])) {
                    propertyAssignmentPromises.push((async () => {
                        instance[propertyKey] = await instance[propertyKey];
                    })());
                }
            }
        }
        if (propertyAssignmentPromises.length > 0) {
            return Promise.all(propertyAssignmentPromises).then(() => undefined);
        }
    };
}

const setInstanceProperties = setInstanceProperties$1(resolveServiceNode);
const resolveServiceRedirectionBindingNode = resolveServiceRedirectionBindingNode$1(resolveBindingNode);
const resolveInstanceBindingNode = resolveInstanceBindingNode$1(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
resolveInstanceBindingConstructorParams(resolveServiceNode), resolveInstanceBindingNodeAsyncFromConstructorParams(resolveInstanceBindingNodeFromConstructorParams(setInstanceProperties)), resolveInstanceBindingNodeFromConstructorParams(setInstanceProperties));
const resolveResolvedValueBindingNode = resolveResolvedValueBindingNode$1(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
resolveResolvedValueBindingParams(resolveServiceNode));
const resolveScopedInstanceBindingNode = resolveScopedInstanceBindingNode$1(resolveInstanceBindingNode);
const resolveScopedResolvedValueBindingNode = resolveScopedResolvedValueBindingNode$1(resolveResolvedValueBindingNode);
function resolve(params) {
    try {
        const serviceNode = params.planResult.tree.root;
        return resolveServiceNode(params, serviceNode);
    }
    catch (error) {
        handleResolveError(params, error);
    }
}
function resolveBindingNode(params, planBindingNode) {
    switch (planBindingNode.binding.type) {
        case bindingTypeValues.ConstantValue:
            return resolveConstantValueBinding(params, planBindingNode.binding);
        case bindingTypeValues.DynamicValue:
            return resolveDynamicValueBinding(params, planBindingNode.binding);
        case bindingTypeValues.Factory:
            return resolveFactoryBinding(params, planBindingNode.binding);
        case bindingTypeValues.Instance:
            return resolveScopedInstanceBindingNode(params, planBindingNode);
        case bindingTypeValues.ResolvedValue:
            return resolveScopedResolvedValueBindingNode(params, planBindingNode);
    }
}
function resolveServiceNode(params, serviceNode) {
    if (serviceNode.bindings === undefined) {
        return undefined;
    }
    if (Array.isArray(serviceNode.bindings)) {
        return resolveMultipleBindingServiceNode(params, serviceNode.bindings);
    }
    return resolveSingleBindingServiceNode(params, serviceNode.bindings);
}
function resolveMultipleBindingServiceNode(params, bindings) {
    const resolvedValues = [];
    for (const binding of bindings) {
        if (isPlanServiceRedirectionBindingNode(binding)) {
            resolvedValues.push(...resolveServiceRedirectionBindingNode(params, binding));
        }
        else {
            resolvedValues.push(resolveBindingNode(params, binding));
        }
    }
    if (resolvedValues.some(isPromise)) {
        return Promise.all(resolvedValues);
    }
    return resolvedValues;
}
function resolveSingleBindingServiceNode(params, binding) {
    if (isPlanServiceRedirectionBindingNode(binding)) {
        const resolvedValues = resolveServiceRedirectionBindingNode(params, binding);
        if (resolvedValues.length === 1) {
            return resolvedValues[0];
        }
        else {
            throw new InversifyCoreError(InversifyCoreErrorKind.resolution, 'Unexpected multiple resolved values on single injection');
        }
    }
    else {
        return resolveBindingNode(params, binding);
    }
}

function isScopedBinding(binding) {
    return (binding.scope !==
        undefined);
}

function resolveBindingPreDestroy(params, binding) {
    if (binding.type === bindingTypeValues.Instance) {
        const classMetadata = params.getClassMetadata(binding.implementationType);
        const instance = binding.cache
            .value;
        if (isPromise(instance)) {
            return instance.then((instance) => resolveInstancePreDestroyMethods(classMetadata, instance));
        }
        else {
            return resolveInstancePreDestroyMethods(classMetadata, instance);
        }
    }
}
function resolveInstancePreDestroyMethod(instance, methodName) {
    if (typeof instance[methodName] === 'function') {
        const result = instance[methodName]();
        return result;
    }
}
function resolveInstancePreDestroyMethods(classMetadata, instance) {
    const preDestroyMethodNames = classMetadata.lifecycle.preDestroyMethodNames;
    if (preDestroyMethodNames.size === 0) {
        return;
    }
    let result = undefined;
    for (const methodName of preDestroyMethodNames) {
        if (result === undefined) {
            result = resolveInstancePreDestroyMethod(instance, methodName);
        }
        else {
            result = result.then(() => resolveInstancePreDestroyMethod(instance, methodName));
        }
    }
    return result;
}

function resolveBindingServiceDeactivations(params, serviceIdentifier, value) {
    const deactivations = params.getDeactivations(serviceIdentifier);
    if (deactivations === undefined) {
        return undefined;
    }
    if (isPromise(value)) {
        return resolveBindingDeactivationsFromIteratorAsync(value, deactivations[Symbol.iterator]());
    }
    return resolveBindingDeactivationsFromIterator(value, deactivations[Symbol.iterator]());
}
function resolveBindingDeactivationsFromIterator(value, deactivationsIterator) {
    let deactivationIteratorResult = deactivationsIterator.next();
    while (deactivationIteratorResult.done !== true) {
        const nextDeactivationValue = deactivationIteratorResult.value(value);
        if (isPromise(nextDeactivationValue)) {
            return resolveBindingDeactivationsFromIteratorAsync(value, deactivationsIterator);
        }
        deactivationIteratorResult = deactivationsIterator.next();
    }
}
async function resolveBindingDeactivationsFromIteratorAsync(value, deactivationsIterator) {
    const resolvedValue = await value;
    let deactivationIteratorResult = deactivationsIterator.next();
    while (deactivationIteratorResult.done !== true) {
        await deactivationIteratorResult.value(resolvedValue);
        deactivationIteratorResult = deactivationsIterator.next();
    }
}

function resolveBindingDeactivations(params, binding) {
    const preDestroyResult = resolveBindingPreDestroy(params, binding);
    if (preDestroyResult === undefined) {
        return resolveBindingDeactivationsAfterPreDestroy(params, binding);
    }
    return preDestroyResult.then(() => resolveBindingDeactivationsAfterPreDestroy(params, binding));
}
function resolveBindingDeactivationsAfterPreDestroy(params, binding) {
    const bindingCache = binding.cache;
    if (isPromise(bindingCache.value)) {
        return bindingCache.value.then((resolvedValue) => resolveBindingDeactivationsAfterPreDestroyFromValue(params, binding, resolvedValue));
    }
    return resolveBindingDeactivationsAfterPreDestroyFromValue(params, binding, bindingCache.value);
}
function resolveBindingDeactivationsAfterPreDestroyFromValue(params, binding, resolvedValue) {
    let deactivationResult = undefined;
    if (binding.onDeactivation !== undefined) {
        const bindingDeactivation = binding.onDeactivation;
        deactivationResult = bindingDeactivation(resolvedValue);
    }
    if (deactivationResult === undefined) {
        return resolveBindingServiceDeactivations(params, binding.serviceIdentifier, resolvedValue);
    }
    else {
        return deactivationResult.then(() => resolveBindingServiceDeactivations(params, binding.serviceIdentifier, resolvedValue));
    }
}

function resolveBindingsDeactivations(params, bindings) {
    if (bindings === undefined) {
        return;
    }
    const singletonScopedBindings = filterCachedSinglentonScopedBindings(bindings);
    const deactivationPromiseResults = [];
    for (const binding of singletonScopedBindings) {
        const deactivationResult = resolveBindingDeactivations(params, binding);
        if (deactivationResult !== undefined) {
            deactivationPromiseResults.push(deactivationResult);
        }
    }
    if (deactivationPromiseResults.length > 0) {
        return Promise.all(deactivationPromiseResults).then(() => undefined);
    }
}
function filterCachedSinglentonScopedBindings(bindings) {
    const filteredBindings = [];
    for (const binding of bindings) {
        if (isScopedBinding(binding) &&
            binding.scope === bindingScopeValues.Singleton &&
            binding.cache.isRight) {
            filteredBindings.push(binding);
        }
    }
    return filteredBindings;
}

function resolveModuleDeactivations(params, moduleId) {
    const bindings = params.getBindingsFromModule(moduleId);
    return resolveBindingsDeactivations(params, bindings);
}

function resolveServiceDeactivations(params, serviceIdentifier) {
    const bindings = params.getBindings(serviceIdentifier);
    return resolveBindingsDeactivations(params, bindings);
}

const bindingIdentifierSymbol = Symbol.for('@inversifyjs/container/bindingIdentifier');

function isBindingIdentifier(value) {
    return (typeof value === 'object' &&
        value !== null &&
        value[bindingIdentifierSymbol] === true);
}

class BindingConstraintUtils {
    static always = (_bindingConstraints) => {
        return true;
    };
}

const isAppErrorSymbol = Symbol.for('@inversifyjs/container/InversifyContainerError');
class InversifyContainerError extends Error {
    [isAppErrorSymbol];
    kind;
    constructor(kind, message, options) {
        super(message, options);
        this[isAppErrorSymbol] = true;
        this.kind = kind;
    }
    static is(value) {
        return (typeof value === 'object' &&
            value !== null &&
            value[isAppErrorSymbol] === true);
    }
    static isErrorOfKind(value, kind) {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        return InversifyContainerError.is(value) && value.kind === kind;
    }
}

var InversifyContainerErrorKind;
(function (InversifyContainerErrorKind) {
    InversifyContainerErrorKind[InversifyContainerErrorKind["invalidOperation"] = 0] = "invalidOperation";
})(InversifyContainerErrorKind || (InversifyContainerErrorKind = {}));

function buildBindingIdentifier(binding) {
    return {
        [bindingIdentifierSymbol]: true,
        id: binding.id,
    };
}

function isAnyAncestorBindingConstraints(condition) {
    return (constraints) => {
        for (let ancestorMetadata = constraints.getAncestor(); ancestorMetadata !== undefined; ancestorMetadata = ancestorMetadata.getAncestor()) {
            if (condition(ancestorMetadata)) {
                return true;
            }
        }
        return false;
    };
}

function isBindingConstraintsWithName(name) {
    return (constraints) => constraints.name === name;
}

function isAnyAncestorBindingConstraintsWithName(name) {
    return isAnyAncestorBindingConstraints(isBindingConstraintsWithName(name));
}

function isBindingConstraintsWithServiceId(serviceId) {
    return (constraints) => constraints.serviceIdentifier === serviceId;
}

function isAnyAncestorBindingConstraintsWithServiceId(serviceId) {
    return isAnyAncestorBindingConstraints(isBindingConstraintsWithServiceId(serviceId));
}

function isBindingConstraintsWithTag(tag, value) {
    return (constraints) => constraints.tags.has(tag) && constraints.tags.get(tag) === value;
}

function isAnyAncestorBindingConstraintsWithTag(tag, value) {
    return isAnyAncestorBindingConstraints(isBindingConstraintsWithTag(tag, value));
}

function isBindingConstraintsWithNoNameNorTags(constraints) {
    return constraints.name === undefined && constraints.tags.size === 0;
}

function isMultipleResolvedValueMetadataInjectOptions(options) {
    return (options
        .isMultiple === true);
}

function isNoAncestorBindingConstraints(condition) {
    const isAnyAncestorBindingConstraintsConstraint = isAnyAncestorBindingConstraints(condition);
    return (constraints) => {
        return !isAnyAncestorBindingConstraintsConstraint(constraints);
    };
}

function isNoAncestorBindingConstraintsWithName(name) {
    return isNoAncestorBindingConstraints(isBindingConstraintsWithName(name));
}

function isNoAncestorBindingConstraintsWithServiceId(serviceId) {
    return isNoAncestorBindingConstraints(isBindingConstraintsWithServiceId(serviceId));
}

function isNoAncestorBindingConstraintsWithTag(tag, value) {
    return isNoAncestorBindingConstraints(isBindingConstraintsWithTag(tag, value));
}

function isNotParentBindingConstraints(condition) {
    return (constraints) => {
        const ancestorMetadata = constraints.getAncestor();
        return ancestorMetadata === undefined || !condition(ancestorMetadata);
    };
}

function isNotParentBindingConstraintsWithName(name) {
    return isNotParentBindingConstraints(isBindingConstraintsWithName(name));
}

function isNotParentBindingConstraintsWithServiceId(serviceId) {
    return isNotParentBindingConstraints(isBindingConstraintsWithServiceId(serviceId));
}

function isNotParentBindingConstraintsWithTag(tag, value) {
    return isNotParentBindingConstraints(isBindingConstraintsWithTag(tag, value));
}

function isParentBindingConstraints(condition) {
    return (constraints) => {
        const ancestorMetadata = constraints.getAncestor();
        return ancestorMetadata !== undefined && condition(ancestorMetadata);
    };
}

function isParentBindingConstraintsWithName(name) {
    return isParentBindingConstraints(isBindingConstraintsWithName(name));
}

function isParentBindingConstraintsWithServiceId(serviceId) {
    return isParentBindingConstraints(isBindingConstraintsWithServiceId(serviceId));
}

function isParentBindingConstraintsWithTag(tag, value) {
    return isParentBindingConstraints(isBindingConstraintsWithTag(tag, value));
}

function isResolvedValueMetadataInjectOptions(options) {
    return typeof options === 'object' && !LazyServiceIdentifier.is(options);
}

class BindInFluentSyntaxImplementation {
    #binding;
    constructor(binding) {
        this.#binding = binding;
    }
    getIdentifier() {
        return buildBindingIdentifier(this.#binding);
    }
    inRequestScope() {
        this.#binding.scope = bindingScopeValues.Request;
        return new BindWhenOnFluentSyntaxImplementation(this.#binding);
    }
    inSingletonScope() {
        this.#binding.scope = bindingScopeValues.Singleton;
        return new BindWhenOnFluentSyntaxImplementation(this.#binding);
    }
    inTransientScope() {
        this.#binding.scope = bindingScopeValues.Transient;
        return new BindWhenOnFluentSyntaxImplementation(this.#binding);
    }
}
class BindToFluentSyntaxImplementation {
    #callback;
    #containerModuleId;
    #defaultScope;
    #serviceIdentifier;
    constructor(callback, containerModuleId, defaultScope, serviceIdentifier) {
        this.#callback = callback;
        this.#containerModuleId = containerModuleId;
        this.#defaultScope = defaultScope;
        this.#serviceIdentifier = serviceIdentifier;
    }
    to(type) {
        const classMetadata = getClassMetadata(type);
        const binding = {
            cache: {
                isRight: false,
                value: undefined,
            },
            id: getBindingId(),
            implementationType: type,
            isSatisfiedBy: BindingConstraintUtils.always,
            moduleId: this.#containerModuleId,
            onActivation: undefined,
            onDeactivation: undefined,
            scope: classMetadata.scope ?? this.#defaultScope,
            serviceIdentifier: this.#serviceIdentifier,
            type: bindingTypeValues.Instance,
        };
        this.#callback(binding);
        return new BindInWhenOnFluentSyntaxImplementation(binding);
    }
    toSelf() {
        if (typeof this.#serviceIdentifier !== 'function') {
            throw new Error('"toSelf" function can only be applied when a newable function is used as service identifier');
        }
        return this.to(this.#serviceIdentifier);
    }
    toConstantValue(value) {
        const binding = {
            cache: {
                isRight: false,
                value: undefined,
            },
            id: getBindingId(),
            isSatisfiedBy: BindingConstraintUtils.always,
            moduleId: this.#containerModuleId,
            onActivation: undefined,
            onDeactivation: undefined,
            scope: bindingScopeValues.Singleton,
            serviceIdentifier: this.#serviceIdentifier,
            type: bindingTypeValues.ConstantValue,
            value: value,
        };
        this.#callback(binding);
        return new BindWhenOnFluentSyntaxImplementation(binding);
    }
    toDynamicValue(builder) {
        const binding = {
            cache: {
                isRight: false,
                value: undefined,
            },
            id: getBindingId(),
            isSatisfiedBy: BindingConstraintUtils.always,
            moduleId: this.#containerModuleId,
            onActivation: undefined,
            onDeactivation: undefined,
            scope: this.#defaultScope,
            serviceIdentifier: this.#serviceIdentifier,
            type: bindingTypeValues.DynamicValue,
            value: builder,
        };
        this.#callback(binding);
        return new BindInWhenOnFluentSyntaxImplementation(binding);
    }
    toResolvedValue(factory, injectOptions) {
        const binding = {
            cache: {
                isRight: false,
                value: undefined,
            },
            factory,
            id: getBindingId(),
            isSatisfiedBy: BindingConstraintUtils.always,
            metadata: this.#buildResolvedValueMetadata(injectOptions),
            moduleId: this.#containerModuleId,
            onActivation: undefined,
            onDeactivation: undefined,
            scope: this.#defaultScope,
            serviceIdentifier: this.#serviceIdentifier,
            type: bindingTypeValues.ResolvedValue,
        };
        this.#callback(binding);
        return new BindInWhenOnFluentSyntaxImplementation(binding);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    toFactory(builder) {
        const binding = {
            cache: {
                isRight: false,
                value: undefined,
            },
            factory: builder,
            id: getBindingId(),
            isSatisfiedBy: BindingConstraintUtils.always,
            moduleId: this.#containerModuleId,
            onActivation: undefined,
            onDeactivation: undefined,
            scope: bindingScopeValues.Singleton,
            serviceIdentifier: this.#serviceIdentifier,
            type: bindingTypeValues.Factory,
        };
        this.#callback(binding);
        return new BindWhenOnFluentSyntaxImplementation(binding);
    }
    toService(service) {
        const binding = {
            id: getBindingId(),
            isSatisfiedBy: BindingConstraintUtils.always,
            moduleId: this.#containerModuleId,
            serviceIdentifier: this.#serviceIdentifier,
            targetServiceIdentifier: service,
            type: bindingTypeValues.ServiceRedirection,
        };
        this.#callback(binding);
    }
    #buildResolvedValueMetadata(options) {
        const resolvedValueMetadata = {
            arguments: (options ?? []).map((injectOption) => {
                if (isResolvedValueMetadataInjectOptions(injectOption)) {
                    if (isMultipleResolvedValueMetadataInjectOptions(injectOption)) {
                        return {
                            chained: injectOption.chained ?? false,
                            kind: ResolvedValueElementMetadataKind.multipleInjection,
                            name: injectOption.name,
                            optional: injectOption.optional ?? false,
                            tags: new Map((injectOption.tags ?? []).map((tag) => [
                                tag.key,
                                tag.value,
                            ])),
                            value: injectOption.serviceIdentifier,
                        };
                    }
                    else {
                        return {
                            kind: ResolvedValueElementMetadataKind.singleInjection,
                            name: injectOption.name,
                            optional: injectOption.optional ?? false,
                            tags: new Map((injectOption.tags ?? []).map((tag) => [
                                tag.key,
                                tag.value,
                            ])),
                            value: injectOption.serviceIdentifier,
                        };
                    }
                }
                else {
                    return {
                        kind: ResolvedValueElementMetadataKind.singleInjection,
                        name: undefined,
                        optional: false,
                        tags: new Map(),
                        value: injectOption,
                    };
                }
            }),
        };
        return resolvedValueMetadata;
    }
}
class BindOnFluentSyntaxImplementation {
    #binding;
    constructor(binding) {
        this.#binding = binding;
    }
    getIdentifier() {
        return buildBindingIdentifier(this.#binding);
    }
    onActivation(activation) {
        this.#binding.onActivation = activation;
        return new BindWhenFluentSyntaxImplementation(this.#binding);
    }
    onDeactivation(deactivation) {
        this.#binding.onDeactivation = deactivation;
        if (this.#binding.scope !== bindingScopeValues.Singleton) {
            throw new InversifyContainerError(InversifyContainerErrorKind.invalidOperation, `Binding for service "${stringifyServiceIdentifier(this.#binding.serviceIdentifier)}" has a deactivation function, but its scope is not singleton. Deactivation functions can only be used with singleton bindings.`);
        }
        return new BindWhenFluentSyntaxImplementation(this.#binding);
    }
}
class BindWhenFluentSyntaxImplementation {
    #binding;
    constructor(binding) {
        this.#binding = binding;
    }
    getIdentifier() {
        return buildBindingIdentifier(this.#binding);
    }
    when(constraint) {
        this.#binding.isSatisfiedBy = constraint;
        return new BindOnFluentSyntaxImplementation(this.#binding);
    }
    whenAnyAncestor(constraint) {
        return this.when(isAnyAncestorBindingConstraints(constraint));
    }
    whenAnyAncestorIs(serviceIdentifier) {
        return this.when(isAnyAncestorBindingConstraintsWithServiceId(serviceIdentifier));
    }
    whenAnyAncestorNamed(name) {
        return this.when(isAnyAncestorBindingConstraintsWithName(name));
    }
    whenAnyAncestorTagged(tag, tagValue) {
        return this.when(isAnyAncestorBindingConstraintsWithTag(tag, tagValue));
    }
    whenDefault() {
        return this.when(isBindingConstraintsWithNoNameNorTags);
    }
    whenNamed(name) {
        return this.when(isBindingConstraintsWithName(name));
    }
    whenNoParent(constraint) {
        return this.when(isNotParentBindingConstraints(constraint));
    }
    whenNoParentIs(serviceIdentifier) {
        return this.when(isNotParentBindingConstraintsWithServiceId(serviceIdentifier));
    }
    whenNoParentNamed(name) {
        return this.when(isNotParentBindingConstraintsWithName(name));
    }
    whenNoParentTagged(tag, tagValue) {
        return this.when(isNotParentBindingConstraintsWithTag(tag, tagValue));
    }
    whenParent(constraint) {
        return this.when(isParentBindingConstraints(constraint));
    }
    whenParentIs(serviceIdentifier) {
        return this.when(isParentBindingConstraintsWithServiceId(serviceIdentifier));
    }
    whenParentNamed(name) {
        return this.when(isParentBindingConstraintsWithName(name));
    }
    whenParentTagged(tag, tagValue) {
        return this.when(isParentBindingConstraintsWithTag(tag, tagValue));
    }
    whenTagged(tag, tagValue) {
        return this.when(isBindingConstraintsWithTag(tag, tagValue));
    }
    whenNoAncestor(constraint) {
        return this.when(isNoAncestorBindingConstraints(constraint));
    }
    whenNoAncestorIs(serviceIdentifier) {
        return this.when(isNoAncestorBindingConstraintsWithServiceId(serviceIdentifier));
    }
    whenNoAncestorNamed(name) {
        return this.when(isNoAncestorBindingConstraintsWithName(name));
    }
    whenNoAncestorTagged(tag, tagValue) {
        return this.when(isNoAncestorBindingConstraintsWithTag(tag, tagValue));
    }
}
class BindWhenOnFluentSyntaxImplementation extends BindWhenFluentSyntaxImplementation {
    #bindOnFluentSyntax;
    constructor(binding) {
        super(binding);
        this.#bindOnFluentSyntax = new BindOnFluentSyntaxImplementation(binding);
    }
    onActivation(activation) {
        return this.#bindOnFluentSyntax.onActivation(activation);
    }
    onDeactivation(deactivation) {
        return this.#bindOnFluentSyntax.onDeactivation(deactivation);
    }
}
class BindInWhenOnFluentSyntaxImplementation extends BindWhenOnFluentSyntaxImplementation {
    #bindInFluentSyntax;
    constructor(binding) {
        super(binding);
        this.#bindInFluentSyntax = new BindInFluentSyntaxImplementation(binding);
    }
    inRequestScope() {
        return this.#bindInFluentSyntax.inRequestScope();
    }
    inSingletonScope() {
        return this.#bindInFluentSyntax.inSingletonScope();
    }
    inTransientScope() {
        return this.#bindInFluentSyntax.inTransientScope();
    }
}

function getFirstIteratorResult(iterator) {
    if (iterator === undefined) {
        return undefined;
    }
    const firstIteratorResult = iterator.next();
    if (firstIteratorResult.done === true) {
        return undefined;
    }
    return firstIteratorResult.value;
}

function getFirstIterableResult(iterable) {
    return getFirstIteratorResult(iterable?.[Symbol.iterator]());
}

class BindingManager {
    #deactivationParams;
    #defaultScope;
    #planResultCacheManager;
    #serviceReferenceManager;
    constructor(deactivationParams, defaultScope, planResultCacheManager, serviceReferenceManager) {
        this.#deactivationParams = deactivationParams;
        this.#defaultScope = defaultScope;
        this.#planResultCacheManager = planResultCacheManager;
        this.#serviceReferenceManager = serviceReferenceManager;
    }
    bind(serviceIdentifier) {
        return new BindToFluentSyntaxImplementation((binding) => {
            this.#setBinding(binding);
        }, undefined, this.#defaultScope, serviceIdentifier);
    }
    isBound(serviceIdentifier, options) {
        const bindings = this.#serviceReferenceManager.bindingService.get(serviceIdentifier);
        return this.#isAnyValidBinding(serviceIdentifier, bindings, options);
    }
    isCurrentBound(serviceIdentifier, options) {
        const bindings = this.#serviceReferenceManager.bindingService.getNonParentBindings(serviceIdentifier);
        return this.#isAnyValidBinding(serviceIdentifier, bindings, options);
    }
    async rebindAsync(serviceIdentifier) {
        await this.unbindAsync(serviceIdentifier);
        return this.bind(serviceIdentifier);
    }
    rebind(serviceIdentifier) {
        this.unbind(serviceIdentifier);
        return this.bind(serviceIdentifier);
    }
    async unbindAsync(identifier) {
        await this.#unbindAsync(identifier);
    }
    async unbindAllAsync() {
        await this.#unbindAll();
    }
    unbindAll() {
        const result = this.#unbindAll();
        if (result !== undefined) {
            throw new InversifyContainerError(InversifyContainerErrorKind.invalidOperation, 'Unexpected asynchronous deactivation when unbinding all services. Consider using Container.unbindAllAsync() instead.');
        }
    }
    unbind(identifier) {
        const result = this.#unbindAsync(identifier);
        if (result !== undefined) {
            this.#throwUnexpectedAsyncUnbindOperation(identifier);
        }
    }
    #setBinding(binding) {
        this.#serviceReferenceManager.bindingService.set(binding);
        this.#planResultCacheManager.invalidateService({
            binding: binding,
            kind: CacheBindingInvalidationKind.bindingAdded,
        });
    }
    #throwUnexpectedAsyncUnbindOperation(identifier) {
        let errorMessage;
        if (isBindingIdentifier(identifier)) {
            const bindingsById = this.#serviceReferenceManager.bindingService.getById(identifier.id);
            const bindingServiceIdentifier = getFirstIterableResult(bindingsById)?.serviceIdentifier;
            if (bindingServiceIdentifier === undefined) {
                errorMessage =
                    'Unexpected asynchronous deactivation when unbinding binding identifier. Consider using Container.unbindAsync() instead.';
            }
            else {
                errorMessage = `Unexpected asynchronous deactivation when unbinding "${stringifyServiceIdentifier(bindingServiceIdentifier)}" binding. Consider using Container.unbindAsync() instead.`;
            }
        }
        else {
            errorMessage = `Unexpected asynchronous deactivation when unbinding "${stringifyServiceIdentifier(identifier)}" service. Consider using Container.unbindAsync() instead.`;
        }
        throw new InversifyContainerError(InversifyContainerErrorKind.invalidOperation, errorMessage);
    }
    #unbindAsync(identifier) {
        if (isBindingIdentifier(identifier)) {
            return this.#unbindBindingIdentifier(identifier);
        }
        return this.#unbindServiceIdentifier(identifier);
    }
    #unbindBindingIdentifier(identifier) {
        const bindingsIterable = this.#serviceReferenceManager.bindingService.getById(identifier.id);
        const bindings = bindingsIterable === undefined ? undefined : [...bindingsIterable];
        const result = resolveBindingsDeactivations(this.#deactivationParams, bindingsIterable);
        if (result === undefined) {
            this.#clearAfterUnbindBindingIdentifier(bindings, identifier);
        }
        else {
            return result.then(() => {
                this.#clearAfterUnbindBindingIdentifier(bindings, identifier);
            });
        }
    }
    #clearAfterUnbindBindingIdentifier(bindings, identifier) {
        this.#serviceReferenceManager.bindingService.removeById(identifier.id);
        if (bindings !== undefined) {
            for (const binding of bindings) {
                this.#planResultCacheManager.invalidateService({
                    binding,
                    kind: CacheBindingInvalidationKind.bindingRemoved,
                });
            }
        }
    }
    #unbindAll() {
        const nonParentBoundServiceIds = [
            ...this.#serviceReferenceManager.bindingService.getNonParentBoundServices(),
        ];
        const deactivationResults = nonParentBoundServiceIds.map((serviceId) => resolveServiceDeactivations(this.#deactivationParams, serviceId));
        const hasAsyncDeactivations = deactivationResults.some((result) => isPromise(result));
        if (hasAsyncDeactivations) {
            // eslint-disable-next-line @typescript-eslint/await-thenable
            return Promise.all(deactivationResults).then(() => {
                this.#clearAfterUnbindAll(nonParentBoundServiceIds);
            });
        }
        this.#clearAfterUnbindAll(nonParentBoundServiceIds);
    }
    #clearAfterUnbindAll(serviceIds) {
        /*
         * Removing service related objects here so unbindAll is deterministic.
         *
         * Removing service related objects as soon as resolveModuleDeactivations takes
         * effect leads to module deactivations not triggering previously deleted
         * deactivations, introducing non determinism depending in the order in which
         * services are deactivated.
         */
        for (const serviceId of serviceIds) {
            this.#serviceReferenceManager.activationService.removeAllByServiceId(serviceId);
            this.#serviceReferenceManager.bindingService.removeAllByServiceId(serviceId);
            this.#serviceReferenceManager.deactivationService.removeAllByServiceId(serviceId);
        }
        this.#serviceReferenceManager.planResultCacheService.clearCache();
    }
    #unbindServiceIdentifier(identifier) {
        const bindingsIterable = this.#serviceReferenceManager.bindingService.get(identifier);
        const bindings = bindingsIterable === undefined ? undefined : [...bindingsIterable];
        const result = resolveBindingsDeactivations(this.#deactivationParams, bindingsIterable);
        if (result === undefined) {
            this.#clearAfterUnbindServiceIdentifier(identifier, bindings);
        }
        else {
            return result.then(() => {
                this.#clearAfterUnbindServiceIdentifier(identifier, bindings);
            });
        }
    }
    #clearAfterUnbindServiceIdentifier(identifier, bindings) {
        this.#serviceReferenceManager.activationService.removeAllByServiceId(identifier);
        this.#serviceReferenceManager.bindingService.removeAllByServiceId(identifier);
        this.#serviceReferenceManager.deactivationService.removeAllByServiceId(identifier);
        if (bindings !== undefined) {
            for (const binding of bindings) {
                this.#planResultCacheManager.invalidateService({
                    binding,
                    kind: CacheBindingInvalidationKind.bindingRemoved,
                });
            }
        }
    }
    #isAnyValidBinding(serviceIdentifier, bindings, options) {
        if (bindings === undefined) {
            return false;
        }
        const bindingConstraints = {
            getAncestor: () => undefined,
            name: options?.name,
            serviceIdentifier,
            tags: new Map(),
        };
        if (options?.tag !== undefined) {
            bindingConstraints.tags.set(options.tag.key, options.tag.value);
        }
        for (const binding of bindings) {
            if (binding.isSatisfiedBy(bindingConstraints)) {
                return true;
            }
        }
        return false;
    }
}

class ContainerModuleManager {
    #bindingManager;
    #deactivationParams;
    #defaultScope;
    #planResultCacheManager;
    #serviceReferenceManager;
    constructor(bindingManager, deactivationParams, defaultScope, planResultCacheManager, serviceReferenceManager) {
        this.#bindingManager = bindingManager;
        this.#deactivationParams = deactivationParams;
        this.#defaultScope = defaultScope;
        this.#planResultCacheManager = planResultCacheManager;
        this.#serviceReferenceManager = serviceReferenceManager;
    }
    async loadAsync(...modules) {
        // eslint-disable-next-line @typescript-eslint/await-thenable
        await Promise.all(this.#load(...modules));
    }
    load(...modules) {
        const results = this.#load(...modules);
        for (const result of results) {
            if (result !== undefined) {
                throw new InversifyContainerError(InversifyContainerErrorKind.invalidOperation, 'Unexpected asynchronous module load. Consider using container.loadAsync() instead.');
            }
        }
    }
    async unloadAsync(...modules) {
        // eslint-disable-next-line @typescript-eslint/await-thenable
        await Promise.all(this.#unload(...modules));
        /*
         * Removing module related objects here so unload is deterministic.
         *
         * Removing modules as soon as resolveModuleDeactivations takes effect leads to
         * module deactivations not triggering previously deleted deactivations,
         * introducing non determinism depending in the order in which modules are
         * deactivated.
         */
        this.#clearAfterUnloadModules(modules);
    }
    unload(...modules) {
        const results = this.#unload(...modules);
        for (const result of results) {
            if (result !== undefined) {
                throw new InversifyContainerError(InversifyContainerErrorKind.invalidOperation, 'Unexpected asynchronous module unload. Consider using container.unloadAsync() instead.');
            }
        }
        /*
         * Removing module related objects here so unload is deterministic.
         *
         * Removing modules as soon as resolveModuleDeactivations takes effect leads to
         * module deactivations not triggering previously deleted deactivations,
         * introducing non determinism depending in the order in which modules are
         * deactivated.
         */
        this.#clearAfterUnloadModules(modules);
    }
    #buildContainerModuleLoadOptions(moduleId) {
        return {
            bind: (serviceIdentifier) => {
                return new BindToFluentSyntaxImplementation((binding) => {
                    this.#setBinding(binding);
                }, moduleId, this.#defaultScope, serviceIdentifier);
            },
            isBound: this.#bindingManager.isBound.bind(this.#bindingManager),
            onActivation: (serviceIdentifier, activation) => {
                this.#serviceReferenceManager.activationService.add(activation, {
                    moduleId,
                    serviceId: serviceIdentifier,
                });
            },
            onDeactivation: (serviceIdentifier, deactivation) => {
                this.#serviceReferenceManager.deactivationService.add(deactivation, {
                    moduleId,
                    serviceId: serviceIdentifier,
                });
            },
            rebind: this.#bindingManager.rebind.bind(this.#bindingManager),
            rebindAsync: this.#bindingManager.rebindAsync.bind(this.#bindingManager),
            unbind: this.#bindingManager.unbind.bind(this.#bindingManager),
            unbindAsync: this.#bindingManager.unbindAsync.bind(this.#bindingManager),
        };
    }
    #clearAfterUnloadModules(modules) {
        for (const module of modules) {
            this.#serviceReferenceManager.activationService.removeAllByModuleId(module.id);
            this.#serviceReferenceManager.bindingService.removeAllByModuleId(module.id);
            this.#serviceReferenceManager.deactivationService.removeAllByModuleId(module.id);
        }
        this.#serviceReferenceManager.planResultCacheService.clearCache();
    }
    #load(...modules) {
        return modules.map((module) => module.load(this.#buildContainerModuleLoadOptions(module.id)));
    }
    #setBinding(binding) {
        this.#serviceReferenceManager.bindingService.set(binding);
        this.#planResultCacheManager.invalidateService({
            binding: binding,
            kind: CacheBindingInvalidationKind.bindingAdded,
        });
    }
    #unload(...modules) {
        return modules.map((module) => resolveModuleDeactivations(this.#deactivationParams, module.id));
    }
}

function resetDeactivationParams(serviceReferenceManager, deactivationParams) {
    deactivationParams.getBindings =
        serviceReferenceManager.bindingService.get.bind(serviceReferenceManager.bindingService);
    deactivationParams.getBindingsFromModule =
        serviceReferenceManager.bindingService.getByModuleId.bind(serviceReferenceManager.bindingService);
    deactivationParams.getDeactivations =
        serviceReferenceManager.deactivationService.get.bind(serviceReferenceManager.deactivationService);
}

function buildDeactivationParams(serviceReferenceManager) {
    return {
        getBindings: serviceReferenceManager.bindingService.get.bind(serviceReferenceManager.bindingService),
        getBindingsFromModule: serviceReferenceManager.bindingService.getByModuleId.bind(serviceReferenceManager.bindingService),
        getClassMetadata,
        getDeactivations: serviceReferenceManager.deactivationService.get.bind(serviceReferenceManager.deactivationService),
    };
}

class DeactivationParamsManager {
    deactivationParams;
    constructor(serviceReferenceManager) {
        this.deactivationParams = buildDeactivationParams(serviceReferenceManager);
        serviceReferenceManager.onReset(() => {
            resetDeactivationParams(serviceReferenceManager, this.deactivationParams);
        });
    }
}

class PlanParamsOperationsManager {
    planParamsOperations;
    #serviceReferenceManager;
    constructor(serviceReferenceManager) {
        this.#serviceReferenceManager = serviceReferenceManager;
        this.planParamsOperations = {
            getBindings: this.#serviceReferenceManager.bindingService.get.bind(this.#serviceReferenceManager.bindingService),
            getBindingsChained: this.#serviceReferenceManager.bindingService.getChained.bind(this.#serviceReferenceManager.bindingService),
            getClassMetadata,
            getPlan: this.#serviceReferenceManager.planResultCacheService.get.bind(this.#serviceReferenceManager.planResultCacheService),
            setBinding: this.#setBinding.bind(this),
            setNonCachedServiceNode: this.#serviceReferenceManager.planResultCacheService.setNonCachedServiceNode.bind(this.#serviceReferenceManager.planResultCacheService),
            setPlan: this.#serviceReferenceManager.planResultCacheService.set.bind(this.#serviceReferenceManager.planResultCacheService),
        };
        this.#serviceReferenceManager.onReset(() => {
            this.#resetComputedProperties();
        });
    }
    #resetComputedProperties() {
        this.planParamsOperations.getBindings =
            this.#serviceReferenceManager.bindingService.get.bind(this.#serviceReferenceManager.bindingService);
        this.planParamsOperations.getBindingsChained =
            this.#serviceReferenceManager.bindingService.getChained.bind(this.#serviceReferenceManager.bindingService);
        this.planParamsOperations.setBinding = this.#setBinding.bind(this);
    }
    #setBinding(binding) {
        this.#serviceReferenceManager.bindingService.set(binding);
        this.#serviceReferenceManager.planResultCacheService.invalidateServiceBinding({
            binding: binding,
            kind: CacheBindingInvalidationKind.bindingAdded,
            operations: this.planParamsOperations,
        });
    }
}

class PlanResultCacheManager {
    #planParamsOperationsManager;
    #serviceReferenceManager;
    constructor(planParamsOperationsManager, serviceReferenceManager) {
        this.#planParamsOperationsManager = planParamsOperationsManager;
        this.#serviceReferenceManager = serviceReferenceManager;
    }
    invalidateService(invalidation) {
        this.#serviceReferenceManager.planResultCacheService.invalidateServiceBinding({
            ...invalidation,
            operations: this.#planParamsOperationsManager.planParamsOperations,
        });
    }
}

const isPlugin = Symbol.for('@inversifyjs/plugin/isPlugin');

class PluginManager {
    #pluginApi;
    #pluginContext;
    #serviceResolutionManager;
    #serviceReferenceManager;
    constructor(container, serviceReferenceManager, serviceResolutionManager) {
        this.#serviceReferenceManager = serviceReferenceManager;
        this.#serviceResolutionManager = serviceResolutionManager;
        this.#pluginApi = this.#buildPluginApi(container);
        this.#pluginContext = this.#buildPluginContext();
    }
    register(container, pluginConstructor) {
        const pluginInstance = new pluginConstructor(container, this.#pluginContext);
        this.#assertIsPlugin(pluginInstance);
        pluginInstance.load(this.#pluginApi);
    }
    #assertIsPlugin(value) {
        if (value[isPlugin] !== true) {
            throw new InversifyContainerError(InversifyContainerErrorKind.invalidOperation, 'Invalid plugin. The plugin must extend the Plugin class');
        }
    }
    #buildPluginApi(container) {
        return {
            define: (name, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            method) => {
                if (Object.prototype.hasOwnProperty.call(container, name)) {
                    throw new InversifyContainerError(InversifyContainerErrorKind.invalidOperation, `Container already has a method named "${String(name)}"`);
                }
                container[name] =
                    method;
            },
            onPlan: this.#serviceResolutionManager.onPlan.bind(this.#serviceResolutionManager),
        };
    }
    #buildPluginContext() {
        const serviceReferenceManager = this.#serviceReferenceManager;
        return {
            get activationService() {
                return serviceReferenceManager.activationService;
            },
            get bindingService() {
                return serviceReferenceManager.bindingService;
            },
            get deactivationService() {
                return serviceReferenceManager.deactivationService;
            },
            get planResultCacheService() {
                return serviceReferenceManager.planResultCacheService;
            },
        };
    }
}

/**
 * Manages references to core services used throughout the Container
 * This class allows for proper synchronization of services during snapshot/restore operations
 */
class ServiceReferenceManager {
    activationService;
    bindingService;
    deactivationService;
    planResultCacheService;
    #onResetComputedPropertiesListeners;
    constructor(activationService, bindingService, deactivationService, planResultCacheService) {
        this.activationService = activationService;
        this.bindingService = bindingService;
        this.deactivationService = deactivationService;
        this.planResultCacheService = planResultCacheService;
        this.#onResetComputedPropertiesListeners = [];
    }
    reset(activationService, bindingService, deactivationService) {
        this.activationService = activationService;
        this.bindingService = bindingService;
        this.deactivationService = deactivationService;
        this.planResultCacheService.clearCache();
        for (const listener of this.#onResetComputedPropertiesListeners) {
            listener();
        }
    }
    onReset(listener) {
        this.#onResetComputedPropertiesListeners.push(listener);
    }
}

class ServiceResolutionManager {
    #autobind;
    #defaultScope;
    #getActivationsResolutionParam;
    #resolutionContext;
    #onPlanHandlers;
    #planParamsOperationsManager;
    #serviceReferenceManager;
    constructor(planParamsOperationsManager, serviceReferenceManager, autobind, defaultScope) {
        this.#planParamsOperationsManager = planParamsOperationsManager;
        this.#serviceReferenceManager = serviceReferenceManager;
        this.#resolutionContext = this.#buildResolutionContext();
        this.#autobind = autobind;
        this.#defaultScope = defaultScope;
        this.#getActivationsResolutionParam = (serviceIdentifier) => this.#serviceReferenceManager.activationService.get(serviceIdentifier);
        this.#onPlanHandlers = [];
        this.#serviceReferenceManager.onReset(() => {
            this.#resetComputedProperties();
        });
    }
    get(serviceIdentifier, options) {
        const planResult = this.#buildPlanResult(false, serviceIdentifier, options);
        const resolvedValue = this.#getFromPlanResult(planResult);
        if (isPromise(resolvedValue)) {
            throw new InversifyContainerError(InversifyContainerErrorKind.invalidOperation, `Unexpected asynchronous service when resolving service "${stringifyServiceIdentifier(serviceIdentifier)}"`);
        }
        return resolvedValue;
    }
    getAll(serviceIdentifier, options) {
        const planResult = this.#buildPlanResult(true, serviceIdentifier, options);
        const resolvedValue = this.#getFromPlanResult(planResult);
        if (isPromise(resolvedValue)) {
            throw new InversifyContainerError(InversifyContainerErrorKind.invalidOperation, `Unexpected asynchronous service when resolving service "${stringifyServiceIdentifier(serviceIdentifier)}"`);
        }
        return resolvedValue;
    }
    async getAllAsync(serviceIdentifier, options) {
        const planResult = this.#buildPlanResult(true, serviceIdentifier, options);
        return this.#getFromPlanResult(planResult);
    }
    async getAsync(serviceIdentifier, options) {
        const planResult = this.#buildPlanResult(false, serviceIdentifier, options);
        return this.#getFromPlanResult(planResult);
    }
    onPlan(handler) {
        this.#onPlanHandlers.push(handler);
    }
    #resetComputedProperties() {
        this.#resolutionContext = this.#buildResolutionContext();
    }
    #buildGetPlanOptions(isMultiple, serviceIdentifier, options) {
        const name = options?.name;
        const optional = options?.optional ?? false;
        const tag = options?.tag;
        if (isMultiple) {
            return {
                chained: options?.chained ?? false,
                isMultiple,
                name,
                optional,
                serviceIdentifier,
                tag,
            };
        }
        else {
            return {
                isMultiple,
                name,
                optional,
                serviceIdentifier,
                tag,
            };
        }
    }
    #buildPlanParams(serviceIdentifier, isMultiple, options) {
        const planParams = {
            autobindOptions: (options?.autobind ?? this.#autobind)
                ? {
                    scope: this.#defaultScope,
                }
                : undefined,
            operations: this.#planParamsOperationsManager.planParamsOperations,
            rootConstraints: this.#buildPlanParamsConstraints(serviceIdentifier, isMultiple, options),
            servicesBranch: [],
        };
        this.#handlePlanParamsRootConstraints(planParams, options);
        return planParams;
    }
    #buildPlanParamsConstraints(serviceIdentifier, isMultiple, options) {
        if (isMultiple) {
            return {
                chained: options?.chained ?? false,
                isMultiple,
                serviceIdentifier,
            };
        }
        else {
            return {
                isMultiple,
                serviceIdentifier,
            };
        }
    }
    #buildPlanResult(isMultiple, serviceIdentifier, options) {
        const getPlanOptions = this.#buildGetPlanOptions(isMultiple, serviceIdentifier, options);
        const planResultFromCache = this.#serviceReferenceManager.planResultCacheService.get(getPlanOptions);
        if (planResultFromCache !== undefined) {
            return planResultFromCache;
        }
        const planResult = plan(this.#buildPlanParams(serviceIdentifier, isMultiple, options));
        for (const handler of this.#onPlanHandlers) {
            handler(getPlanOptions, planResult);
        }
        return planResult;
    }
    #buildResolutionContext() {
        return {
            get: this.get.bind(this),
            getAll: this.getAll.bind(this),
            getAllAsync: this.getAllAsync.bind(this),
            getAsync: this.getAsync.bind(this),
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
    #getFromPlanResult(planResult) {
        return resolve({
            context: this.#resolutionContext,
            getActivations: this.#getActivationsResolutionParam,
            planResult,
            requestScopeCache: new Map(),
        });
    }
    #handlePlanParamsRootConstraints(planParams, options) {
        if (options === undefined) {
            return;
        }
        if (options.name !== undefined) {
            planParams.rootConstraints.name = options.name;
        }
        if (options.optional === true) {
            planParams.rootConstraints.isOptional = true;
        }
        if (options.tag !== undefined) {
            planParams.rootConstraints.tag = {
                key: options.tag.key,
                value: options.tag.value,
            };
        }
        if (planParams.rootConstraints.isMultiple) {
            planParams.rootConstraints.chained =
                options?.chained ?? false;
        }
    }
}

class SnapshotManager {
    #serviceReferenceManager;
    #snapshots;
    constructor(serviceReferenceManager) {
        this.#serviceReferenceManager = serviceReferenceManager;
        this.#snapshots = [];
    }
    restore() {
        const snapshot = this.#snapshots.pop();
        if (snapshot === undefined) {
            throw new InversifyContainerError(InversifyContainerErrorKind.invalidOperation, 'No snapshot available to restore');
        }
        this.#serviceReferenceManager.reset(snapshot.activationService, snapshot.bindingService, snapshot.deactivationService);
    }
    snapshot() {
        this.#snapshots.push({
            activationService: this.#serviceReferenceManager.activationService.clone(),
            bindingService: this.#serviceReferenceManager.bindingService.clone(),
            deactivationService: this.#serviceReferenceManager.deactivationService.clone(),
        });
    }
}

const DEFAULT_DEFAULT_SCOPE = bindingScopeValues.Transient;
class Container {
    #bindingManager;
    #containerModuleManager;
    #pluginManager;
    #serviceReferenceManager;
    #serviceResolutionManager;
    #snapshotManager;
    constructor(options) {
        const autobind = options?.autobind ?? false;
        const defaultScope = options?.defaultScope ?? DEFAULT_DEFAULT_SCOPE;
        this.#serviceReferenceManager = this.#buildServiceReferenceManager(options, autobind, defaultScope);
        const planParamsOperationsManager = new PlanParamsOperationsManager(this.#serviceReferenceManager);
        const planResultCacheManager = new PlanResultCacheManager(planParamsOperationsManager, this.#serviceReferenceManager);
        const deactivationParamsManager = new DeactivationParamsManager(this.#serviceReferenceManager);
        this.#bindingManager = new BindingManager(deactivationParamsManager.deactivationParams, defaultScope, planResultCacheManager, this.#serviceReferenceManager);
        this.#containerModuleManager = new ContainerModuleManager(this.#bindingManager, deactivationParamsManager.deactivationParams, defaultScope, planResultCacheManager, this.#serviceReferenceManager);
        this.#serviceResolutionManager = new ServiceResolutionManager(planParamsOperationsManager, this.#serviceReferenceManager, autobind, defaultScope);
        this.#pluginManager = new PluginManager(this, this.#serviceReferenceManager, this.#serviceResolutionManager);
        this.#snapshotManager = new SnapshotManager(this.#serviceReferenceManager);
    }
    bind(serviceIdentifier) {
        return this.#bindingManager.bind(serviceIdentifier);
    }
    get(serviceIdentifier, options) {
        return this.#serviceResolutionManager.get(serviceIdentifier, options);
    }
    getAll(serviceIdentifier, options) {
        return this.#serviceResolutionManager.getAll(serviceIdentifier, options);
    }
    async getAllAsync(serviceIdentifier, options) {
        return this.#serviceResolutionManager.getAllAsync(serviceIdentifier, options);
    }
    async getAsync(serviceIdentifier, options) {
        return this.#serviceResolutionManager.getAsync(serviceIdentifier, options);
    }
    isBound(serviceIdentifier, options) {
        return this.#bindingManager.isBound(serviceIdentifier, options);
    }
    isCurrentBound(serviceIdentifier, options) {
        return this.#bindingManager.isCurrentBound(serviceIdentifier, options);
    }
    async loadAsync(...modules) {
        return this.#containerModuleManager.loadAsync(...modules);
    }
    load(...modules) {
        this.#containerModuleManager.load(...modules);
    }
    onActivation(serviceIdentifier, activation) {
        this.#serviceReferenceManager.activationService.add(activation, {
            serviceId: serviceIdentifier,
        });
    }
    onDeactivation(serviceIdentifier, deactivation) {
        this.#serviceReferenceManager.deactivationService.add(deactivation, {
            serviceId: serviceIdentifier,
        });
    }
    register(pluginConstructor) {
        this.#pluginManager.register(this, pluginConstructor);
    }
    restore() {
        this.#snapshotManager.restore();
    }
    async rebindAsync(serviceIdentifier) {
        return this.#bindingManager.rebindAsync(serviceIdentifier);
    }
    rebind(serviceIdentifier) {
        return this.#bindingManager.rebind(serviceIdentifier);
    }
    snapshot() {
        this.#snapshotManager.snapshot();
    }
    async unbindAsync(identifier) {
        await this.#bindingManager.unbindAsync(identifier);
    }
    async unbindAllAsync() {
        await this.#bindingManager.unbindAllAsync();
    }
    unbindAll() {
        this.#bindingManager.unbindAll();
    }
    unbind(identifier) {
        this.#bindingManager.unbind(identifier);
    }
    async unloadAsync(...modules) {
        return this.#containerModuleManager.unloadAsync(...modules);
    }
    unload(...modules) {
        this.#containerModuleManager.unload(...modules);
    }
    #buildAutobindOptions(autobind, defaultScope) {
        if (autobind) {
            return { scope: defaultScope };
        }
        return undefined;
    }
    #buildServiceReferenceManager(options, autobind, defaultScope) {
        const autobindOptions = this.#buildAutobindOptions(autobind, defaultScope);
        if (options?.parent === undefined) {
            return new ServiceReferenceManager(ActivationsService.build(() => undefined), BindingService.build(() => undefined, autobindOptions), DeactivationsService.build(() => undefined), new PlanResultCacheService());
        }
        const planResultCacheService = new PlanResultCacheService();
        const parent = options.parent;
        parent.#serviceReferenceManager.planResultCacheService.subscribe(planResultCacheService);
        return new ServiceReferenceManager(ActivationsService.build(() => parent.#serviceReferenceManager.activationService), BindingService.build(() => parent.#serviceReferenceManager.bindingService, autobindOptions), DeactivationsService.build(() => parent.#serviceReferenceManager.deactivationService), planResultCacheService);
    }
}

/** */
class SlideBuilder {
    constructor(textBuilder) {
        this.textBuilder = textBuilder;
    }
    build(slide) {
        let builtSlide = {
            "attrs": {}
        };
        let background = {
            "attrs": {}
        };
        if (slide.imageSrc) {
            background.attrs.src = slide.imageSrc;
            background.className = "Image";
        }
        else {
            background.attrs.x = 0;
            background.attrs.y = 0;
            background.attrs.fill = "black";
            background.attrs.height = 643;
            background.attrs.width = 981;
            background.className = "Rect";
        }
        if (slide.text) {
            builtSlide.className = "Group";
            builtSlide.attrs.height = 643;
            builtSlide.attrs.width = 981;
            builtSlide.children = [];
            builtSlide.children.push(background);
            builtSlide.children.push(this.textBuilder.build(slide.text));
        }
        else {
            builtSlide = background;
        }
        builtSlide.attrs.visible = false;
        builtSlide.attrs.category = "sequence";
        builtSlide.attrs.id = slide.id;
        return builtSlide;
    }
}

/** */
class TextBuilder {
    constructor() {
    }
    build(text) {
        let builtText = {
            "attrs": {}
        };
        builtText.attrs.text = text.text;
        builtText.attrs.fontFamily = "Chalkboard SE";
        builtText.attrs.fontSize = 26;
        builtText.attrs.fill = "white";
        builtText.attrs.shadowColor = "#bbbbbb";
        builtText.attrs.shadowBlur = 10;
        builtText.attrs.width = 981;
        builtText.attrs.align = "center";
        builtText.attrs.y = 321;
        builtText.className = "Text";
        return builtText;
    }
}

/** */
class SequenceBuilder {
    constructor(slideBuilder) {
        this.slideBuilder = slideBuilder;
    }
    build(slides, key) {
        const builtSequence = {
            attrs: {},
            children: [],
            className: "Group"
        };
        builtSequence.attrs.category = 'sequence';
        builtSequence.attrs.visible = false;
        builtSequence.attrs.id = key;
        for (const [index, slide] of slides.entries()) {
            builtSequence.children.push(this.slideBuilder.build(slide));
        }
        return builtSequence;
    }
}

class ItemBuilder {
    constructor() {
    }
    build(data, key) {
        const item = {
            attrs: {
                "category": data.category,
                "id": key,
                "src": data.src,
                "visible": false,
                "draggable": true,
                "animated": false,
                "width": 80,
                "height": 80,
            },
            className: "Image"
        };
        return item;
    }
}

class ItemsBuilder {
    constructor(itemBuilder) {
        this.itemBuilder = itemBuilder;
    }
    build(items_json) {
        const builtItems = [];
        for (const key in items_json) {
            builtItems.push(this.itemBuilder.build(items_json[key], key));
        }
        return builtItems;
    }
}

const UiEventEmitter = Symbol.for("UIEventEmitter");
decorate(injectable(), TextBuilder);
decorate(injectable(), SlideBuilder);
decorate(injectable(), SequenceBuilder);
decorate(injectable(), ItemBuilder);
decorate(injectable(), ItemsBuilder);
decorate(inject(TextBuilder), SlideBuilder, 0);
decorate(inject(SlideBuilder), SequenceBuilder, 0);
decorate(inject(ItemBuilder), ItemsBuilder, 0);
const engineContainerModule = new ContainerModule(({ bind }) => {
    bind(TextBuilder).to(TextBuilder);
    bind(SlideBuilder).to(SlideBuilder);
    bind(SequenceBuilder).to(SequenceBuilder);
    bind(ItemBuilder).to(ItemBuilder);
    bind(ItemsBuilder).to(ItemsBuilder);
    bind(UiEventEmitter).to(EventEmitter).inSingletonScope();
});
const container = new Container();
container.load(gameStateEngineModule, engineContainerModule);

export { ItemsBuilder as I, SequenceBuilder as S, UiEventEmitter as U, container as a, commonjsGlobal as c, engineContainerModule as e, getDefaultExportFromCjs as g };
//# sourceMappingURL=inversify.config-BUYxyzIu.js.map
